/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AdminAccount {
  /** @format int64 */
  id?: number
  type?: string
  active?: boolean
  email?: string
  phone?: string
  attributes?: AdminAccountAttributes
  createdAt?: string
  updatedAt?: string
}

export interface AdminAccountAttributes {
  /** [Optional] */
  tags?: string[]
  /** [Optional] */
  labels?: Record<string, string>
}

export interface AdminAccountBalance {
  /** @format int64 */
  credit?: number
  /** @format int64 */
  creditsPending?: number
  /** @format int64 */
  debit?: number
  /** @format int64 */
  debitsPending?: number
  /** @format int64 */
  posted?: number
  /** @format int64 */
  pending?: number
  /** @format int64 */
  available?: number
}

export interface AdminAccountPortfolio {
  type?: 'fiat' | 'crypto' | 'asset' | 'project'
  currency?: string
  /** @format int64 */
  balance?: number
  /** @format int64 */
  availableBalance?: number
  /** @format int64 */
  estimatedBalance?: number
  /** @format int64 */
  estimatedAvailableBalance?: number
  delta24H?: AdminPortfolioDelta
  delta7D?: AdminPortfolioDelta
  delta30D?: AdminPortfolioDelta
}

export interface AdminAgencyInfo {
  name?: string
  address?: string
}

export interface AdminAgentDiscount {
  type?: 'percentage' | 'fixed'
  /** @format double */
  value?: number
}

export interface AdminAgentInfo {
  agencyName?: string
  agencyAddress?: string
}

export interface AdminAgentKYCData {
  firstName?: string
  lastName?: string
  nationalID?: string
  birthDate?: string
  /** [Optional] */
  files?: AdminKYCDocument[]
}

export interface AdminAgentKYCSession {
  /** @format int64 */
  id?: number
  /** @format int64 */
  userID?: number
  workflowID?: string
  /** @format int64 */
  status?: number
  data?: AdminAgentKYCData
  createdAt?: string
  updatedAt?: string
}

export interface AdminAuditPostInput {
  /** @format int64 */
  auditorID?: number
  /** @format int64 */
  postID?: number
  accepted?: boolean
  /** [Optional] */
  comments?: string[]
}

export interface AdminAuditPostOutput {
  post?: AdminPost
}

export interface AdminAuthorDetails {
  firstName?: string
  lastName?: string
  displayName?: string
  /** [Optional] */
  photo?: AdminUserPhoto
  /** [Optional] */
  socials?: AdminSocial[]
  /** [Optional] */
  agency?: AdminAgencyInfo
}

export interface AdminBackofficeDepositOutput {
  workflowID?: string
}

export interface AdminBackofficeFiatDepositInput {
  /** @format int64 */
  userID?: number
  /** @format int64 */
  amount?: number
  reference?: string
  currency?: string
  note?: string
}

export interface AdminBirthdate {
  /** @format int64 */
  year?: number
  /** @format int64 */
  month?: number
  /** @format int64 */
  day?: number
}

export interface AdminBootstrapInput {
  buckets?: boolean
  druidSupervisors?: boolean
  projects?: boolean
  messagesTopics?: boolean
  portfolioJobs?: boolean
}

export interface AdminBootstrapOutput {
  success?: boolean
}

export interface AdminCity {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface AdminCloseTicketInput {
  /** @format int64 */
  ticketID?: number
  comment?: string
  approved?: boolean
  /** @format int64 */
  closedBy?: number
}

export interface AdminCloseTicketOutput {
  ticket?: AdminTransferTicket
}

export interface AdminCompleteWithdrawalFiatInput {
  /** @format int64 */
  transactionID?: number
  /** @format int64 */
  userID?: number
  comment?: string
  status?: 'completed' | 'failed' | 'canceled' | 'rejected'
}

export interface AdminCompleteWithdrawalFiatOutput {
  transaction?: AdminFiatTransaction
}

export interface AdminCounty {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface AdminCoverPhoto {
  url?: string
}

export interface AdminCreateAccountInput {
  accountType?: 'user' | 'service'
  email?: string
  phone?: string
  active?: boolean
  /** [Optional] */
  tags?: string[]
  /** [Optional] */
  labels?: Record<string, string>
}

export interface AdminCreateAccountOutput {
  account?: AdminAccount
}

export interface AdminCreateEmailOTPInput {
  email?: string
}

export interface AdminCreateOTPInput {
  phone?: string
}

export interface AdminCreateOTPOutput {
  /** @format int64 */
  otp?: number
  /** @format int64 */
  digits?: number
}

export interface AdminCreateProjectInput {
  token?: string
  displayName?: string
  description?: string
  kind?: 'property' | 'crypto'
  /** @format int64 */
  scale?: number
  type?:
    | 'residential'
    | 'commercial'
    | 'office'
    | 'touristic'
    | 'industrial'
    | 'agricultural'
    | 'mining'
    | 'transportation'
    | 'other'
    | 'land'
  state?:
    | 'planning'
    | 'under_construction'
    | 'completed'
    | 'occupied'
    | 'for_sale'
    | 'for_rent'
    | 'other'
  tradeStatus?:
    | 'active'
    | 'suspended'
    | 'delisting'
    | 'coming_soon'
    | 'off_market'
  location?: AdminProjectLocationInput
  /** [Optional] */
  geoLocation?: AdminProjectGeoLocation
  /** [Optional] */
  details?: AdminDetailedData[]
}

export interface AdminCreateProjectOutput {
  project?: AdminProject
}

export interface AdminData {
  cat?: string
  subCat?: string
  /** @format base64 */
  data?: string
}

export interface AdminDeleteDocumentInput {
  /** @format int64 */
  projectID?: number
  /** @format int64 */
  documentID?: number
}

export interface AdminDeleteDocumentOutput {
  success?: boolean
}

export interface AdminDeleteLocationInput {
  /** @format int64 */
  id?: number
}

export interface AdminDeleteLocationOutput {
  success?: boolean
}

export interface AdminDeletePhotoInput {
  /** @format int64 */
  projectID?: number
  /** @format int64 */
  photoID?: number
}

export interface AdminDeletePhotoOutput {
  success?: boolean
}

export interface AdminDeletePostInput {
  /** @format int64 */
  postID?: number
}

export interface AdminDeletePostOutput {
  success?: boolean
}

export interface AdminDeleteProjectLogoInput {
  /** @format int64 */
  projectID?: number
}

export interface AdminDeleteProjectLogoOutput {
  success?: boolean
}

export interface AdminDeleteUserInput {
  /** @format int64 */
  userID?: number
}

export interface AdminDeleteUserOutput {
  userDeleted?: boolean
}

export interface AdminDetailedData {
  key?: string
  /** @format base64 */
  value?: string
  valueType?: 'string' | 'number' | 'boolean' | 'array' | 'object'
  /** [Optional] */
  annotations?: AdminDetailedDataAnnotations[]
}

export interface AdminDetailedDataAnnotations {
  key?: string
  value?: string
}

export interface AdminDetails {
  firstName?: string
  lastName?: string
  displayName?: string
  birthDate?: string
  /** [Optional] */
  kyc?: AdminUserKYC
  /** [Optional] */
  photo?: AdminUserPhoto
  /** [Optional] */
  coverPhoto?: AdminCoverPhoto
  /** [Optional] */
  finDetails?: AdminUserFinDetails
  /** [Optional] */
  referral?: AdminUserReferral
  /** [Optional] */
  socials?: AdminUserSocials
  /** [Optional] */
  agentInfo?: AdminAgentInfo
}

export interface AdminDistrict {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface AdminError {
  /** @format int64 */
  code?: number
  codeName?: string
  item?: string
  ''?: string
}

export interface AdminFiatDeposit {
  provider?: string
  final?: boolean
  reference?: string
  sessionID?: string
  type?: string
}

export interface AdminFiatRefund {
  reference?: string
  /** @format int64 */
  originalTxn?: number
}

export interface AdminFiatTransaction {
  /** @format int64 */
  id?: number
  /** @format int64 */
  userID?: number
  /** @format int64 */
  amount?: number
  /** @format int64 */
  effectiveAmount?: number
  currency?: string
  status?: 'completed' | 'pending' | 'failed' | 'canceled' | 'rejected'
  createdAt?: string
  updatedAt?: string
  /** [Optional] */
  deposit?: AdminFiatDeposit
  /** [Optional] */
  withdrawal?: AdminFiatWithdrawal
  /** [Optional] */
  refund?: AdminFiatRefund
  comment?: string
}

export interface AdminFiatWithdrawal {
  /** @format int64 */
  reference?: number
  iban?: string
}

export interface AdminFinalizeAgentKYCInput {
  workflowID?: string
  ok?: boolean
  comment?: string
}

export interface AdminFinalizeAgentKYCOutput {
  ok?: boolean
}

export interface AdminFinalizeVideoKYCInput {
  workflowID?: string
  ok?: boolean
  comment?: string
}

export interface AdminFinalizeVideoKYCOutput {
  ok?: boolean
}

export interface AdminGetAccountByEmailInput {
  email?: string
}

export interface AdminGetAccountByPhoneInput {
  phone?: string
}

export interface AdminGetAccountInput {
  /** @format int64 */
  id?: number
}

export interface AdminGetLiquidityAccountsInput {
  account?: 'otc' | 'fiat' | 'loyalty'
}

export interface AdminGetLiquidityAccountsOutput {
  /** [Optional] */
  accounts?: AdminWalletAccount[]
  /** [Optional] */
  ledgers?: AdminLedger[]
}

export interface AdminGetMissionsInput {
  /** @format int64 */
  userID?: number
}

export interface AdminGetMissionsOutput {
  /** [Optional] */
  missions?: AdminUserMission[]
}

export interface AdminGetOTCHistoryInput {
  /**
   * [Optional]
   * @format int64
   */
  userID?: number
  /**
   * [Optional]
   * @format int64
   */
  agentID?: number
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
  /** [Optional] */
  targetCurrency?: string
  /** [Optional] */
  baseCurrency?: string
}

export interface AdminGetOTCHistoryOutput {
  /** [Optional] */
  transactions?: AdminOTCTransaction[]
  /** [Optional] */
  users?: AdminUser[]
}

export interface AdminGetProjectAgentLinksInput {
  /** @format int64 */
  userID?: number
  onlyActives?: boolean
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface AdminGetProjectAgentLinksOutput {
  /** [Optional] */
  links?: AdminProjectAgentLink[]
  /** [Optional] */
  agents?: AdminUser[]
  /** [Optional] */
  projects?: AdminProject[]
}

export interface AdminGetProjectInput {
  /**
   * [Optional]
   * @format int64
   */
  userID?: number
  token?: string
}

export interface AdminGetProjectOutput {
  project?: AdminProject
}

export interface AdminGetProjectPriceExprInput {
  /** @format int64 */
  projectID?: number
}

export interface AdminGetProjectPriceExprOutput {
  expr?: string
  /** @format int64 */
  spreadPlus?: number
  /** @format int64 */
  spreadMinus?: number
}

export interface AdminGetUploadLinkOutput {
  url?: string
  /** [Optional] */
  formData?: Record<string, string>
}

export interface AdminGetUserByEmailInput {
  userType?: 'user' | 'agent'
  email?: string
}

export interface AdminGetUserByIDInput {
  /** @format int64 */
  id?: number
}

export interface AdminGetUserByPhoneInput {
  userType?: 'user' | 'agent'
  phone?: string
}

export interface AdminGetUserPortfolioInput {
  /** @format int64 */
  userID?: number
  userType?: string
  estimateCurrency?: string
}

export interface AdminGetUserPortfolioOutput {
  /** [Optional] */
  accounts?: AdminAccountPortfolio[]
  estimated?: AdminAccountPortfolio
  /** [Optional] */
  ledgers?: AdminLedger[]
  /** [Optional] */
  projects?: AdminProject[]
}

export interface AdminKYCDocument {
  /** @format int64 */
  id?: number
  name?: string
  bucket?: string
  contentType?: string
  /** [Optional] */
  meta?: Record<string, string>
  /** @format int64 */
  size?: number
}

export interface AdminLedger {
  /** @format int64 */
  id?: number
  name?: string
  /** @format int64 */
  scale?: number
  /** [Optional] */
  ''?: Record<string, string>
}

export interface AdminListAccountsInput {
  type?: string
  /** @format int64 */
  page?: number
  /** @format int64 */
  pageSize?: number
}

export interface AdminListAccountsOutput {
  /** [Optional] */
  accounts?: AdminAccount[]
  /** @format int64 */
  total?: number
}

export interface AdminListAgentKYCsInput {
  /**
   * [Optional]
   * @format int64
   */
  userID?: number
  /**
   * [Optional]
   * @format int64
   */
  status?: number
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface AdminListAgentKYCsOutput {
  /** [Optional] */
  sessions?: AdminAgentKYCSession[]
}

export interface AdminListFiatTransactionsInput {
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
  deposits?: boolean
  withdrawals?: boolean
  /**
   * [Optional]
   * @format int64
   */
  userID?: number
  /** [Optional] */
  currency?: string
  /** [Optional] */
  status?: 'completed' | 'pending' | 'failed' | 'canceled'
}

export interface AdminListFiatTransactionsOutput {
  /** [Optional] */
  transactions?: AdminFiatTransaction[]
  /** [Optional] */
  users?: AdminUser[]
}

export interface AdminListPostsInput {
  /** [Optional] */
  projectID?: number[]
  /** [Optional] */
  authorID?: number[]
  /** [Optional] */
  auditorID?: number[]
  /** [Optional] */
  status?: 'in_review' | 'published' | 'accepted' | 'rejected' | 'draft'
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface AdminListPostsOutput {
  /** @format int64 */
  total?: number
  /** [Optional] */
  posts?: AdminPost[]
  /** [Optional] */
  projects?: AdminProject[]
  /** [Optional] */
  authors?: AdminPostAuthor[]
  /** [Optional] */
  links?: AdminProjectAgentLink[]
}

export interface AdminListProjectAgentLinksInput {
  /**
   * [Optional]
   * @format int64
   */
  projectID?: number
  /** [Optional] */
  status?: 'wait_for_review' | 'accepted' | 'rejected'
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface AdminListProjectAgentLinksOutput {
  /** [Optional] */
  links?: AdminProjectAgentLink[]
  /** [Optional] */
  agents?: AdminUser[]
  /** [Optional] */
  projects?: AdminProject[]
}

export interface AdminListProjectsInput {
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
  /** [Optional] */
  q?: string
  /** [Optional] */
  kind?: 'property' | 'crypto'
  /** [Optional] */
  type?:
    | 'residential'
    | 'commercial'
    | 'office'
    | 'touristic'
    | 'industrial'
    | 'agricultural'
    | 'mining'
    | 'transportation'
    | 'other'
    | 'land'
  /** [Optional] */
  state?:
    | 'planning'
    | 'under_construction'
    | 'completed'
    | 'occupied'
    | 'for_sale'
    | 'for_rent'
    | 'other'
  /** [Optional] */
  tradeStatus?:
    | 'active'
    | 'suspended'
    | 'delisting'
    | 'coming_soon'
    | 'off_market'
  /**
   * [Optional]
   * @format int64
   */
  provinceID?: number
  /**
   * [Optional]
   * @format int64
   */
  countyID?: number
  /**
   * [Optional]
   * @format int64
   */
  cityID?: number
  /**
   * [Optional]
   * @format int64
   */
  districtID?: number
  /** [Optional] */
  orderBy?: 'expensive' | 'cheapest' | 'gainer' | 'loser' | 'newest'
  /**
   * [Optional]
   * @format int64
   */
  priceMin?: number
  /**
   * [Optional]
   * @format int64
   */
  priceMax?: number
  /** [Optional] */
  excludeIDs?: number[]
}

export interface AdminListProjectsOutput {
  /** @format int64 */
  total?: number
  /** [Optional] */
  projects?: AdminProject[]
}

export interface AdminListTicketInput {
  /** [Optional] */
  from?: string
  /** [Optional] */
  to?: string
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
  /** [Optional] */
  transferType?:
    | 'between_users'
    | 'deposit_bank'
    | 'card_to_card'
    | 'withdrawal'
  /**
   * [Optional]
   * @format int64
   */
  userID?: number
  /** [Optional] */
  iban?: string
  /** [Optional] */
  card?: string
}

export interface AdminListTransferTicketsOutput {
  /** [Optional] */
  tickets?: AdminTransferTicket[]
  /** [Optional] */
  users?: AdminUser[]
  /** [Optional] */
  accounts?: AdminAccount[]
}

export interface AdminListUserBankAccountsInput {
  /** @format int64 */
  userID?: number
}

export interface AdminListUserBankAccountsOutput {
  /** [Optional] */
  banks?: AdminUserBank[]
}

export interface AdminListUsersInput {
  userType?: 'user' | 'agent'
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface AdminListUsersOutput {
  /** [Optional] */
  users?: AdminUser[]
}

export interface AdminListVideoKYCsInput {
  /**
   * [Optional]
   * @format int64
   */
  userID?: number
  /**
   * [Optional]
   * @format int64
   */
  status?: number
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface AdminListVideoKYCsOutput {
  /** [Optional] */
  sessions?: AdminVideoKYCSession[]
}

export interface AdminLoginByEmailInput {
  email?: string
  /** @format int64 */
  otp?: number
  code?: string
}

export interface AdminLoginByEmailOutput {
  /** @format int64 */
  userID?: number
  accessToken?: string
  refreshToken?: string
}

export interface AdminLoginByPhoneInput {
  phone?: string
  /** @format int64 */
  otp?: number
  code?: string
}

export interface AdminLoginByPhoneOutput {
  /** @format int64 */
  userID?: number
  accessToken?: string
  refreshToken?: string
}

export interface AdminMission {
  /** @format int64 */
  id?: number
  name?: string
  /** @format int64 */
  points?: number
  defaultEnabled?: boolean
  data?: AdminMissionData
}

export interface AdminMissionData {
  milestone?: AdminMissionMilestone
  dependency?: AdminMissionDependency
}

export interface AdminMissionDependency {
  /** [Optional] */
  missions?: string[]
}

export interface AdminMissionMilestone {
  /** @format int64 */
  totalSteps?: number
}

export interface AdminOTCOrder {
  id?: string
  /** @format int64 */
  userID?: number
  userType?: string
  /** [Optional] */
  referral?: AdminOTCReferral
  baseCurrency?: string
  /** @format int64 */
  baseAmount?: number
  targetCurrency?: string
  /** @format int64 */
  targetAmount?: number
  orderType?: string
  /** [Optional] */
  charges?: AdminOTCOrderCharge[]
  /** @format int64 */
  createdAt?: number
}

export interface AdminOTCOrderCharge {
  currency?: string
  /** @format int64 */
  value?: number
  key?: string
  type?: string
  /** [Optional] */
  desc?: AdminOrderChargeDesc
}

export interface AdminOTCReferral {
  /** @format int64 */
  userID?: number
  userUUID?: string
  userType?: string
  name?: string
  /** [Optional] */
  photo?: AdminOTCReferralPhoto
  discountCode?: string
  dismissable?: boolean
}

export interface AdminOTCReferralPhoto {
  smallUrl?: string
  largeUrl?: string
}

export interface AdminOTCTransaction {
  /** @format int64 */
  id?: number
  /** @format int64 */
  userID?: number
  userType?: string
  /**
   * [Optional]
   * @format int64
   */
  agentID?: number
  /**
   * [Optional]
   * @format int64
   */
  agentAmount?: number
  baseCurrency?: string
  /** @format int64 */
  baseAmount?: number
  targetCurrency?: string
  /** @format int64 */
  targetAmount?: number
  order?: AdminOTCOrder
  createdAt?: string
}

export interface AdminOrderChargeDesc {
  title?: string
  /** @format double */
  value?: number
  valueType?: 'percent' | 'fixed'
}

export interface AdminPortfolioDelta {
  /** @format double */
  percent?: number
  /** @format int64 */
  amount?: number
  /** @format double */
  orgPercent?: number
  /** @format int64 */
  orgAmount?: number
}

export interface AdminPost {
  /** @format int64 */
  id?: number
  /** @format int64 */
  authorID?: number
  /** @format int64 */
  projectID?: number
  /**
   * [Optional]
   * @format int64
   */
  auditorID?: number
  text?: string
  /** [Optional] */
  audit?: AdminPostAudit
  status?: string
  createdAt?: string
  updatedAt?: string
  /** @format int64 */
  edits?: number
  body?: string
  /** [Optional] */
  pros?: string[]
  /** [Optional] */
  cons?: string[]
  /** [Optional] */
  photos?: AdminPostPhoto[]
  /** [Optional] */
  documents?: AdminPostDocument[]
}

export interface AdminPostAudit {
  /** @format int64 */
  auditorID?: number
  accepted?: boolean
  /** [Optional] */
  comments?: string[]
}

export interface AdminPostAuthor {
  /** @format int64 */
  userID?: number
  userType?: string
  uuid?: string
  username?: string
  details?: AdminAuthorDetails
  joined?: string
}

export interface AdminPostDocument {
  /** @format int64 */
  id?: number
  docURL?: string
  thumbURL?: string
  title?: string
  subTitle?: string
  description?: string
}

export interface AdminPostPhoto {
  /** @format int64 */
  id?: number
  smallURL?: string
  bigURL?: string
}

export interface AdminPrepareProjectDocumentUploadInput {
  /** @format int64 */
  projectID?: number
}

export interface AdminPrepareProjectDocumentUploadOutput {
  upload?: AdminGetUploadLinkOutput
  filename?: string
}

export interface AdminPrepareProjectLogoUploadInput {
  /** @format int64 */
  projectID?: number
}

export interface AdminPrepareProjectLogoUploadOutput {
  upload?: AdminGetUploadLinkOutput
  filename?: string
}

export interface AdminPrepareProjectPhotoUploadInput {
  /** @format int64 */
  projectID?: number
}

export interface AdminPrepareProjectPhotoUploadOutput {
  upload?: AdminGetUploadLinkOutput
  filename?: string
}

export interface AdminPriceRange {
  /** @format double */
  first?: number
  /** @format double */
  last?: number
  /** @format double */
  delta?: number
  /** @format double */
  deltaPercent?: number
}

export interface AdminProject {
  /** @format int64 */
  id?: number
  /** @format int64 */
  priority?: number
  token?: string
  /** @format int64 */
  scale?: number
  displayName?: string
  description?: string
  kind?: string
  type?: string
  state?: string
  tradeStatus?: string
  location?: AdminProjectLocation
  /** [Optional] */
  geoLocation?: AdminProjectGeoLocation
  /** @format int64 */
  defaultPhotoID?: number
  logoURL?: string
  /** [Optional] */
  photos?: AdminPostPhoto[]
  /** [Optional] */
  documents?: AdminPostDocument[]
  /** [Optional] */
  details?: AdminDetailedData[]
  market?: AdminProjectMarketDetails
  price?: AdminProjectPriceDetails
  circulation?: AdminProjectCirculationDetails
  createdAt?: string
}

export interface AdminProjectAgentLink {
  /** @format int64 */
  agentID?: number
  /** @format int64 */
  projectID?: number
  discount?: AdminAgentDiscount
  status?: 'wait_for_review' | 'accepted' | 'rejected'
  active?: boolean
  createdAt?: string
  updatedAt?: string
}

export interface AdminProjectCirculationDetails {
  /** @format int64 */
  otcBuy?: number
  /** @format int64 */
  otcSell?: number
  /** @format int64 */
  otcCirculating?: number
}

export interface AdminProjectDocument {
  /** @format int64 */
  id?: number
  bucket?: string
  name?: string
}

export interface AdminProjectGeoLocation {
  /** @format double */
  latitude?: number
  /** @format double */
  longitude?: number
}

export interface AdminProjectLocation {
  province?: AdminProvince
  county?: AdminCounty
  city?: AdminCity
  district?: AdminDistrict
  rural?: AdminRural
}

export interface AdminProjectLocationInput {
  /** @format int64 */
  provinceID?: number
  /** @format int64 */
  countyID?: number
  /** @format int64 */
  cityID?: number
  /**
   * [Optional]
   * @format int64
   */
  districtID?: number
  /**
   * [Optional]
   * @format int64
   */
  ruralID?: number
}

export interface AdminProjectMarketDetails {
  /** @format int64 */
  maxSupply?: number
  /** @format int64 */
  totalSupply?: number
  /** @format int64 */
  releaseDate?: number
  /** @format int64 */
  listingDate?: number
  /** @format int64 */
  minOrderSize?: number
}

export interface AdminProjectPriceDetails {
  /** @format double */
  volume24h?: number
  /** @format double */
  marketCap?: number
  /** @format double */
  fullyDilutedMarketCap?: number
  /** @format double */
  circulatingCap?: number
  priceRange24h?: AdminPriceRange
  priceRange7d?: AdminPriceRange
  priceRange30d?: AdminPriceRange
}

export interface AdminProvince {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface AdminRefreshTokenInput {
  refreshToken?: string
}

export interface AdminRefreshTokenOutput {
  accessToken?: string
  refreshToken?: string
}

export interface AdminResendOTPInput {
  /** @format int64 */
  otp?: number
  /** [Optional] */
  email?: string
  /** [Optional] */
  phone?: string
}

export interface AdminResendOTPOutput {
  success?: boolean
}

export interface AdminRural {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface AdminSaveMissionInput {
  mission?: AdminMission
}

export interface AdminSaveMissionOutput {
  mission?: AdminMission
}

export interface AdminSavePriceInput {
  symbol?: string
  base?: string
  /** @format double */
  price?: number
}

export interface AdminSavePriceOutput {
  success?: boolean
}

export interface AdminSetAccountAttributesInput {
  /** @format int64 */
  id?: number
  /** [Optional] */
  tags?: string[]
  /** [Optional] */
  labels?: Record<string, string>
}

export interface AdminSetEmailInput {
  /** @format int64 */
  accountID?: number
  email?: string
}

export interface AdminSetLocationInput {
  /** @format int64 */
  id?: number
  type?: string
  name?: string
  slug?: string
  /**
   * [Optional]
   * @format int64
   */
  provinceID?: number
  /**
   * [Optional]
   * @format int64
   */
  countyID?: number
  /**
   * [Optional]
   * @format int64
   */
  cityID?: number
}

export interface AdminSetLocationOutput {
  success?: boolean
}

export interface AdminSetPhoneInput {
  /** @format int64 */
  accountID?: number
  phone?: string
}

export interface AdminSetProjectDefaultPhotoInput {
  /** @format int64 */
  projectID?: number
  /** @format int64 */
  photoID?: number
}

export interface AdminSetProjectDefaultPhotoOutput {
  project?: AdminProject
}

export interface AdminSetProjectMarketDetailsInput {
  token?: string
  /** @format int64 */
  maxSupply?: number
  /** @format int64 */
  totalSupply?: number
  /** @format int64 */
  minOrderSize?: number
  /** @format int64 */
  releaseDateUnix?: number
  /** @format int64 */
  listingDateUnix?: number
}

export interface AdminSetProjectMarketDetailsOutput {
  project?: AdminProject
}

export interface AdminSetProjectPriceExprInput {
  /** @format int64 */
  projectID?: number
  expr?: string
  /**
   * [Optional]
   * @format int64
   */
  spreadPlus?: number
  /**
   * [Optional]
   * @format int64
   */
  spreadMinus?: number
}

export interface AdminSetProjectPriceExprOutput {
  success?: boolean
}

export interface AdminSetProjectPriorityInput {
  /** @format int64 */
  projectID?: number
  /** @format int64 */
  priority?: number
}

export interface AdminSetProjectPriorityOutput {
  success?: boolean
}

export interface AdminSocial {
  platform?: string
  link?: string
}

export interface AdminTicketClosingDetails {
  comment?: string
  /** @format int64 */
  closedBy?: number
  approved?: boolean
}

export interface AdminTicketDetails {
  /** [Optional] */
  iban?: string
  /** [Optional] */
  card?: string
  /**
   * [Optional]
   * @format int64
   */
  receiverUserID?: number
  /** @format int64 */
  amount?: number
  currency?: string
}

export interface AdminToggleAccountActiveInput {
  /** @format int64 */
  id?: number
  active?: boolean
}

export interface AdminTransferTicket {
  /** @format int64 */
  id?: number
  createdAt?: string
  /** @format int64 */
  userID?: number
  transferType?: string
  transferID?: string
  details?: AdminTicketDetails
  closingDetails?: AdminTicketClosingDetails
  closed?: boolean
}

export interface AdminUpdateProjectAgentLinkStatusInput {
  /** @format int64 */
  projectID?: number
  /** @format int64 */
  agentID?: number
  status?: 'accepted' | 'rejected'
}

export interface AdminUpdateProjectAgentLinkStatusOutput {
  link?: AdminProjectAgentLink
}

export interface AdminUpdateUserPersonalInfoInput {
  /** @format int64 */
  userID?: number
  /** [Optional] */
  nationalID?: string
  /** [Optional] */
  birthdate?: AdminBirthdate
}

export interface AdminUploadProjectDocumentOutput {
  /** @format int64 */
  docID?: number
  document?: AdminProjectDocument
  thumbnail?: AdminProjectDocument
}

export interface AdminUploadProjectLogoOutput {
  url?: string
  success?: boolean
}

export interface AdminUploadProjectPhotoOutput {
  /** @format int64 */
  photoID?: number
  resized?: AdminProjectDocument
  thumbnail?: AdminProjectDocument
}

export interface AdminUser {
  /** @format int64 */
  id?: number
  userType?: string
  uuid?: string
  username?: string
  email?: string
  phone?: string
  nationalID?: string
  details?: AdminDetails
  joined?: string
  /** [Optional] */
  deletedAt?: string
  /** [Optional] */
  data?: AdminData[]
}

export interface AdminUserBank {
  /** @format int64 */
  id?: number
  type?: string
  data?: string
  default?: boolean
  details?: AdminUserBankDetails
  /** [Optional] */
  labels?: Record<string, string>
  createdAt?: string
}

export interface AdminUserBankDetails {
  /** [Optional] */
  owners?: AdminUserBankOwner[]
  iban?: string
  bankName?: string
  accountNumber?: string
}

export interface AdminUserBankOwner {
  firstName?: string
  lastName?: string
  nationalID?: string
}

export interface AdminUserFinDetails {
  /** @format int64 */
  feeLevel?: number
}

export interface AdminUserKYC {
  status?: 'waiting_for_review' | 'under_review' | 'approved' | 'rejected'
  /** @format int64 */
  level?: number
  comment?: string
  /** [Optional] */
  ''?: Record<string, string>
}

export interface AdminUserMission {
  mission?: AdminMission
  enabled?: boolean
  status?: 'started' | 'completed' | 'expired'
  milestone?: AdminUserMissionMilestone
}

export interface AdminUserMissionMilestone {
  /** @format int64 */
  completedSteps?: number
  /** @format int64 */
  receivedPoints?: number
}

export interface AdminUserPhoto {
  smallURL?: string
  largeURL?: string
}

export interface AdminUserReferral {
  /** @format int64 */
  userID?: number
  userType?: 'user' | 'agent'
  code?: string
  uuid?: string
}

export interface AdminUserSocial {
  platform?: string
  link?: string
}

export interface AdminUserSocials {
  /** [Optional] */
  platforms?: AdminUserSocial[]
}

export interface AdminVerifyProjectDocumentUploadInput {
  /** @format int64 */
  projectID?: number
  bucket?: string
  fileName?: string
  title?: string
  subTitle?: string
  description?: string
}

export interface AdminVerifyProjectDocumentUploadOutput {
  docURL?: string
  thumbURL?: string
}

export interface AdminVerifyProjectLogoUploadInput {
  /** @format int64 */
  projectID?: number
  bucket?: string
  fileName?: string
}

export interface AdminVerifyProjectLogoUploadOutput {
  url?: string
}

export interface AdminVerifyProjectPhotoUploadInput {
  /** @format int64 */
  projectID?: number
  bucket?: string
  fileName?: string
}

export interface AdminVerifyProjectPhotoUploadOutput {
  smallURL?: string
  bigURL?: string
}

export interface AdminVideoKYCData {
  firstName?: string
  lastName?: string
  nationalID?: string
  birthDate?: string
  /** [Optional] */
  files?: AdminKYCDocument[]
}

export interface AdminVideoKYCSession {
  /** @format int64 */
  id?: number
  /** @format int64 */
  userID?: number
  workflowID?: string
  /** @format int64 */
  status?: number
  data?: AdminVideoKYCData
  createdAt?: string
  updatedAt?: string
}

export interface AdminWalletAccount {
  /** @format int64 */
  id?: number
  /** @format int64 */
  userID?: number
  userType?: string
  /** @format int64 */
  type?: number
  name?: string
  currency?: string
  balance?: AdminAccountBalance
}

export interface AgentAccountPassword {
  hasPassword?: boolean
  hint?: string
  algorithmData?: AgentAlgorithmV6AData
  /** @format base64 */
  srpB?: string
  /** @format base64 */
  randomData?: string
}

export interface AgentAccountPortfolio {
  type?: 'fiat' | 'crypto' | 'asset' | 'project'
  currency?: string
  /** @format int64 */
  balance?: number
  /** @format int64 */
  availableBalance?: number
  /** @format int64 */
  estimatedBalance?: number
  /** @format int64 */
  estimatedAvailableBalance?: number
  delta24H?: AgentPortfolioDelta
  delta7D?: AgentPortfolioDelta
  delta30D?: AgentPortfolioDelta
}

export interface AgentAddAgentDocumentInput {
  workflowID?: string
  name?: string
  contentType?: string
  /** [Optional] */
  meta?: Record<string, string>
}

export interface AgentAddPostInput {
  token?: string
  text?: string
  /** [Optional] */
  cons?: string[]
  /** [Optional] */
  pros?: string[]
  /** [Optional] */
  photos?: AgentPhotoInput[]
  /** [Optional] */
  documents?: AgentDocumentInput[]
}

export interface AgentAddPostOutput {
  post?: AgentPost
}

export interface AgentAddUserBankAccountInput {
  type?: 'card' | 'iban'
  value?: string
  /** [Optional] */
  labels?: Record<string, string>
  addIBAN?: boolean
}

export interface AgentAddUserBankAccountOutput {
  bankAccount?: AgentBankAccount
}

export interface AgentAgencyInfo {
  name?: string
  address?: string
}

export interface AgentAgentDiscount {
  type?: 'percentage' | 'fixed'
  /** @format double */
  value?: number
}

export interface AgentAgentGeneralPerformance {
  /** @format int64 */
  profileVisits?: number
  /** @format int64 */
  profileVisitChange?: number
  /** @format double */
  profileVisitChangePercent?: number
  /** @format int64 */
  newUserReferrals?: number
  /** @format int64 */
  newUserReferralsChange?: number
  /** @format double */
  newUserReferralsChangePercent?: number
}

export interface AgentAgentGeneralPerformanceSummary {
  performance24h?: AgentAgentGeneralPerformance
  performance7d?: AgentAgentGeneralPerformance
  performance30d?: AgentAgentGeneralPerformance
}

export interface AgentAgentInfo {
  agencyName?: string
  agencyAddress?: string
}

export interface AgentAgentKYCStartInput {
  nationalID?: string
  birthdate?: AgentBirthdate
}

export interface AgentAgentTradePerformance {
  currency?: string
  /** @format int64 */
  otcIncome?: number
  /** @format int64 */
  otcIncomeChange?: number
  /** @format double */
  otcIncomeChangePercent?: number
  /** @format int64 */
  otcTrades?: number
  /** @format int64 */
  otcTradesChange?: number
  /** @format double */
  otcTradesChangePercent?: number
  /** @format int64 */
  otcTokens?: number
  /** @format int64 */
  otcTokensChange?: number
  /** @format double */
  otcTokensChangePercent?: number
}

export interface AgentAgentTradePerformanceChart {
  /** @format int64 */
  time?: number
  currency?: string
  /** @format int64 */
  userID?: number
  /** @format int64 */
  otcIncome?: number
  /** @format int64 */
  otcTrades?: number
  /** @format int64 */
  otcTokens?: number
}

export interface AgentAgentTradePerformanceSummary {
  performance24h?: AgentAgentTradePerformance
  performance7d?: AgentAgentTradePerformance
  performance30d?: AgentAgentTradePerformance
}

export interface AgentAlgorithmV6AData {
  /** @format base64 */
  salt1?: string
  /** @format base64 */
  salt2?: string
  /** @format int64 */
  g?: number
  /** @format base64 */
  p?: string
}

export interface AgentAuthorDetails {
  firstName?: string
  lastName?: string
  displayName?: string
  /** [Optional] */
  photo?: AgentUserPhoto
  /** [Optional] */
  socials?: AgentSocial[]
  /** [Optional] */
  agency?: AgentAgencyInfo
}

export interface AgentBankAccount {
  /** @format int64 */
  id?: number
  type?: string
  data?: string
  default?: boolean
  details?: AgentBankDetails
  /** [Optional] */
  labels?: Record<string, string>
  createdAt?: string
}

export interface AgentBankDetails {
  /** [Optional] */
  owners?: AgentBankOwner[]
  iban?: string
  bankName?: string
  accountNumber?: string
}

export interface AgentBankOwner {
  firstName?: string
  lastName?: string
  nationalID?: string
}

export interface AgentBirthdate {
  /** @format int64 */
  year?: number
  /** @format int64 */
  month?: number
  /** @format int64 */
  day?: number
}

export interface AgentCalculateWithdrawalCostInput {
  /** @format int64 */
  amount?: number
  currency?: string
}

export interface AgentCalculateWithdrawalCostOutput {
  /** @format int64 */
  amount?: number
  /** @format int64 */
  charge?: number
  /** @format int64 */
  netAmount?: number
  /** @format int64 */
  grossAmount?: number
  currency?: string
}

export interface AgentCancelWithdrawalFiatInput {
  /** @format int64 */
  transactionID?: number
  comment?: string
}

export interface AgentCancelWithdrawalFiatOutput {
  transaction?: AgentFiatTransaction
}

export interface AgentCheckUserInput {
  /** [Optional] */
  phone?: string
  /** [Optional] */
  email?: string
}

export interface AgentCheckUserOutput {
  exists?: boolean
  hasPassword?: boolean
  /** [Optional] */
  accountPassword?: AgentAccountPassword
}

export interface AgentCity {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface AgentCounty {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface AgentCoverPhoto {
  url?: string
}

export interface AgentCreateEmailOTPInput {
  email?: string
}

export interface AgentCreateOTPInput {
  phone?: string
}

export interface AgentCreateOTPOutput {
  /** @format int64 */
  otp?: number
  /** @format int64 */
  digits?: number
}

export interface AgentCreateProjectAgentLinkOutput {
  link?: AgentProjectAgentLink
}

export interface AgentCreateProjectLinkInput {
  token?: string
  discount?: AgentAgentDiscount
}

export interface AgentData {
  cat?: string
  subCat?: string
  /** @format base64 */
  data?: string
}

export interface AgentDeleteBankAccountsInput {
  /** [Optional] */
  ids?: number[]
}

export interface AgentDeleteBankAccountsOutput {
  /** [Optional] */
  bankAccounts?: AgentBankAccount[]
}

export interface AgentDeletePostDocumentInput {
  /** @format int64 */
  postID?: number
  /** @format int64 */
  documentID?: number
}

export interface AgentDeletePostDocumentOutput {
  success?: boolean
}

export interface AgentDeletePostPhotoInput {
  /** @format int64 */
  postID?: number
  /** @format int64 */
  photoID?: number
}

export interface AgentDeletePostPhotoOutput {
  success?: boolean
}

export interface AgentDetailedData {
  key?: string
  /** @format base64 */
  value?: string
  valueType?: 'string' | 'number' | 'boolean' | 'array' | 'object'
  /** [Optional] */
  annotations?: AgentDetailedDataAnnotations[]
}

export interface AgentDetailedDataAnnotations {
  key?: string
  value?: string
}

export interface AgentDetails {
  firstName?: string
  lastName?: string
  displayName?: string
  birthDate?: string
  /** [Optional] */
  kyc?: AgentUserKYC
  /** [Optional] */
  photo?: AgentUserPhoto
  /** [Optional] */
  coverPhoto?: AgentCoverPhoto
  /** [Optional] */
  finDetails?: AgentUserFinDetails
  /** [Optional] */
  referral?: AgentUserReferral
  /** [Optional] */
  socials?: AgentUserSocials
  /** [Optional] */
  agentInfo?: AgentAgentInfo
}

export interface AgentDistrict {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface AgentDocumentInput {
  docURL?: string
  thumbURL?: string
  title?: string
  subTitle?: string
  description?: string
}

export interface AgentEditPostInput {
  /** @format int64 */
  postID?: number
  body?: string
  /** [Optional] */
  pros?: string[]
  /** [Optional] */
  cons?: string[]
}

export interface AgentEditPostOutput {
  post?: AgentPost
}

export interface AgentError {
  /** @format int64 */
  code?: number
  codeName?: string
  item?: string
  ''?: string
}

export interface AgentFiatDeposit {
  provider?: string
  final?: boolean
  reference?: string
  sessionID?: string
  type?: string
}

export interface AgentFiatRefund {
  reference?: string
  /** @format int64 */
  originalTxn?: number
}

export interface AgentFiatTransaction {
  /** @format int64 */
  id?: number
  /** @format int64 */
  userID?: number
  /** @format int64 */
  amount?: number
  /** @format int64 */
  effectiveAmount?: number
  currency?: string
  status?: 'completed' | 'pending' | 'failed' | 'canceled' | 'rejected'
  createdAt?: string
  updatedAt?: string
  /** [Optional] */
  deposit?: AgentFiatDeposit
  /** [Optional] */
  withdrawal?: AgentFiatWithdrawal
  /** [Optional] */
  refund?: AgentFiatRefund
  comment?: string
}

export interface AgentFiatWithdrawal {
  /** @format int64 */
  reference?: number
  iban?: string
}

export interface AgentGetAgentPerformanceOutput {
  otcTrades?: AgentAgentTradePerformanceSummary
  general?: AgentAgentGeneralPerformanceSummary
}

export interface AgentGetAgentTradePerformanceChartInput {
  period?: '1d' | '1w' | '1M' | '6M'
}

export interface AgentGetAgentTradePerformanceChartOutput {
  /** [Optional] */
  data?: AgentAgentTradePerformanceChart[]
}

export type AgentGetBankAccountsInput = object

export interface AgentGetBankAccountsOutput {
  /** [Optional] */
  bankAccounts?: AgentBankAccount[]
}

export interface AgentGetFiatTransactionHistoryInput {
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
  /** [Optional] */
  currency?: string
  deposits?: boolean
  withdrawals?: boolean
}

export interface AgentGetFiatTransactionHistoryOutput {
  /** [Optional] */
  transactions?: AgentFiatTransaction[]
  /** [Optional] */
  ledgers?: AgentLedger[]
}

export interface AgentGetOTCHistoryOutput {
  /** [Optional] */
  transactions?: AgentOTCTransaction[]
  /** [Optional] */
  users?: AgentUser[]
}

export type AgentGetPasswordSettingsInput = object

export interface AgentGetPasswordSettingsOutput {
  algorithmData?: AgentAlgorithmV6AData
  hint?: string
  /** @format base64 */
  srpHash?: string
}

export type AgentGetPerformanceInput = object

export interface AgentGetPortfolioChartInput {
  /** [Optional] */
  currency?: string
  period?: '1d' | '1w' | '1M' | '6M'
}

export interface AgentGetPortfolioChartOutput {
  /** [Optional] */
  data?: AgentPortfolioChartData[]
  /** [Optional] */
  ledgers?: AgentLedger[]
}

export interface AgentGetProjectInput {
  token?: string
}

export interface AgentGetProjectOutput {
  project?: AgentProject
}

export type AgentGetReferralCodesInput = object

export interface AgentGetReferralCodesOutput {
  /** [Optional] */
  codes?: AgentReferralCode[]
}

export interface AgentGetUploadLinkOutput {
  url?: string
  /** [Optional] */
  formData?: Record<string, string>
}

export type AgentGetUserFiatPortfolioInput = object

export interface AgentGetUserPortfolioOutput {
  /** [Optional] */
  accounts?: AgentAccountPortfolio[]
  estimated?: AgentAccountPortfolio
  /** [Optional] */
  ledgers?: AgentLedger[]
  /** [Optional] */
  projects?: AgentProject[]
}

export interface AgentGetWalletPortfolioChartInput {
  orgCurrency?: string
  /** [Optional] */
  currency?: string
  period?: '1h' | '1d' | '1w' | '1M'
}

export interface AgentGetWalletPortfolioChartOutput {
  /** [Optional] */
  data?: AgentWalletPortfolioChartData[]
  /** [Optional] */
  ledgers?: AgentLedger[]
}

export interface AgentInboxListMessagesInput {
  /** [Optional] */
  messageType?: 'security' | 'system' | 'announcement' | 'otc' | 'payment'
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface AgentInboxListMessagesOutput {
  /** [Optional] */
  messages?: AgentUserMessage[]
}

export interface AgentInboxMarkAllAsReadOutput {
  success?: boolean
}

export interface AgentInboxMarkAllReadInput {
  until?: string
}

export interface AgentInboxMarkAsReadOutput {
  success?: boolean
}

export interface AgentInboxMarkReadInput {
  /** @format int64 */
  msgID?: number
}

export interface AgentKYCDocument {
  /** @format int64 */
  id?: number
  name?: string
  bucket?: string
  contentType?: string
  /** [Optional] */
  meta?: Record<string, string>
  /** @format int64 */
  size?: number
}

export interface AgentLedger {
  /** @format int64 */
  id?: number
  name?: string
  /** @format int64 */
  scale?: number
  /** [Optional] */
  ''?: Record<string, string>
}

export interface AgentListAvailableProjectsInput {
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
  /** [Optional] */
  q?: string
  /** [Optional] */
  type?:
    | 'residential'
    | 'commercial'
    | 'industrial'
    | 'office'
    | 'agricultural'
    | 'touristic'
    | 'mining'
    | 'transportation'
    | 'other'
  /** [Optional] */
  state?:
    | 'planning'
    | 'under_construction'
    | 'completed'
    | 'occupied'
    | 'for_sale'
    | 'for_rent'
    | 'other'
  /**
   * [Optional]
   * @format int64
   */
  provinceID?: number
  /**
   * [Optional]
   * @format int64
   */
  countyID?: number
  /**
   * [Optional]
   * @format int64
   */
  cityID?: number
  /**
   * [Optional]
   * @format int64
   */
  districtID?: number
  /** [Optional] */
  orderBy?: 'expensive' | 'cheapest' | 'gainer' | 'loser' | 'newest'
  /**
   * [Optional]
   * @format int64
   */
  priceMin?: number
  /**
   * [Optional]
   * @format int64
   */
  priceMax?: number
}

export interface AgentListAvailableProjectsOutput {
  /** @format int64 */
  total?: number
  /** [Optional] */
  projects?: AgentProject[]
}

export interface AgentListMyProjectsInput {
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface AgentListMyProjectsOutput {
  /** @format int64 */
  total?: number
  /** [Optional] */
  projects?: AgentProject[]
  /** [Optional] */
  posts?: AgentPost[]
}

export interface AgentListPostsInput {
  /**
   * [Optional]
   * @format int64
   */
  projectID?: number
  /**
   * [Optional]
   * @format int64
   */
  authorID?: number
  /** [Optional] */
  status?: 'in_review' | 'published' | 'accepted' | 'rejected' | 'draft'
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface AgentListPostsOutput {
  /** @format int64 */
  total?: number
  /** [Optional] */
  posts?: AgentPost[]
  /** [Optional] */
  projects?: AgentProject[]
  /** [Optional] */
  authors?: AgentPostAuthor[]
  /** [Optional] */
  links?: AgentProjectAgentLink[]
}

export interface AgentListProjectsInput {
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
  /** [Optional] */
  q?: string
  /** [Optional] */
  type?:
    | 'residential'
    | 'commercial'
    | 'industrial'
    | 'office'
    | 'agricultural'
    | 'touristic'
    | 'mining'
    | 'transportation'
    | 'other'
  /** [Optional] */
  state?:
    | 'planning'
    | 'under_construction'
    | 'completed'
    | 'occupied'
    | 'for_sale'
    | 'for_rent'
    | 'other'
  /**
   * [Optional]
   * @format int64
   */
  provinceID?: number
  /**
   * [Optional]
   * @format int64
   */
  countyID?: number
  /**
   * [Optional]
   * @format int64
   */
  cityID?: number
  /**
   * [Optional]
   * @format int64
   */
  districtID?: number
  /** [Optional] */
  orderBy?: 'expensive' | 'cheapest' | 'gainer' | 'loser' | 'newest'
  /**
   * [Optional]
   * @format int64
   */
  priceMin?: number
  /**
   * [Optional]
   * @format int64
   */
  priceMax?: number
}

export interface AgentListProjectsOutput {
  /** @format int64 */
  total?: number
  /** [Optional] */
  projects?: AgentProject[]
}

export interface AgentLoginByEmailInput {
  email?: string
  /** @format int64 */
  otp?: number
  code?: string
}

export interface AgentLoginByEmailOutput {
  userID?: string
  accessToken?: string
  refreshToken?: string
}

export interface AgentLoginByPasswordInput {
  /** [Optional] */
  phone?: string
  /** [Optional] */
  email?: string
  /** @format base64 */
  a?: string
  /** @format base64 */
  m1?: string
}

export interface AgentLoginByPasswordOutput {
  userID?: string
  accessToken?: string
  refreshToken?: string
}

export interface AgentLoginByPhoneInput {
  phone?: string
  /** @format int64 */
  otp?: number
  code?: string
}

export interface AgentLoginByPhoneOutput {
  userID?: string
  accessToken?: string
  refreshToken?: string
}

export interface AgentMessageAction {
  key?: string
  url?: string
  expiresAt?: string
}

export interface AgentMessageBody {
  format?: string
  /** [Optional] */
  args?: string[]
}

export interface AgentMessageMeta {
  /** [Optional] */
  action?: AgentMessageAction
}

export interface AgentOTCGetHistoryInput {
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
  /** [Optional] */
  targetCurrency?: string
  /** [Optional] */
  baseCurrency?: string
}

export interface AgentOTCOrder {
  id?: string
  /** @format int64 */
  userID?: number
  userType?: string
  /** [Optional] */
  referral?: AgentOTCReferral
  baseCurrency?: string
  /** @format int64 */
  baseAmount?: number
  targetCurrency?: string
  /** @format int64 */
  targetAmount?: number
  orderType?: string
  /** [Optional] */
  charges?: AgentOTCOrderCharge[]
  /** @format int64 */
  createdAt?: number
}

export interface AgentOTCOrderCharge {
  currency?: string
  /** @format int64 */
  value?: number
  key?: string
  type?: string
  /** [Optional] */
  desc?: AgentOrderChargeDesc
}

export interface AgentOTCReferral {
  /** @format int64 */
  userID?: number
  userUUID?: string
  userType?: string
  name?: string
  /** [Optional] */
  photo?: AgentOTCReferralPhoto
  discountCode?: string
  dismissable?: boolean
}

export interface AgentOTCReferralPhoto {
  smallUrl?: string
  largeUrl?: string
}

export interface AgentOTCTransaction {
  /** @format int64 */
  id?: number
  /** @format int64 */
  userID?: number
  userType?: string
  /**
   * [Optional]
   * @format int64
   */
  agentID?: number
  /**
   * [Optional]
   * @format int64
   */
  agentAmount?: number
  baseCurrency?: string
  /** @format int64 */
  baseAmount?: number
  targetCurrency?: string
  /** @format int64 */
  targetAmount?: number
  order?: AgentOTCOrder
  createdAt?: string
}

export interface AgentOrderChargeDesc {
  title?: string
  /** @format double */
  value?: number
  valueType?: 'percent' | 'fixed'
}

export interface AgentPhotoInput {
  smallURL?: string
  bigURL?: string
}

export interface AgentPortfolioChartData {
  /** @format int64 */
  time?: number
  /** @format int64 */
  balance?: number
  /** @format int64 */
  availableBalance?: number
  /** @format int64 */
  count?: number
}

export interface AgentPortfolioDelta {
  /** @format double */
  percent?: number
  /** @format int64 */
  amount?: number
}

export interface AgentPost {
  /** @format int64 */
  id?: number
  /** @format int64 */
  authorID?: number
  /** @format int64 */
  projectID?: number
  /**
   * [Optional]
   * @format int64
   */
  auditorID?: number
  text?: string
  /** [Optional] */
  audit?: AgentPostAudit
  status?: string
  createdAt?: string
  updatedAt?: string
  /** @format int64 */
  edits?: number
  body?: string
  /** [Optional] */
  pros?: string[]
  /** [Optional] */
  cons?: string[]
  /** [Optional] */
  photos?: AgentPostPhoto[]
  /** [Optional] */
  documents?: AgentPostDocument[]
}

export interface AgentPostAudit {
  /** @format int64 */
  auditorID?: number
  accepted?: boolean
  /** [Optional] */
  comments?: string[]
}

export interface AgentPostAuthor {
  /** @format int64 */
  userID?: number
  userType?: string
  uuid?: string
  username?: string
  details?: AgentAuthorDetails
  joined?: string
}

export interface AgentPostDocument {
  /** @format int64 */
  id?: number
  docURL?: string
  thumbURL?: string
  title?: string
  subTitle?: string
  description?: string
}

export interface AgentPostPhoto {
  /** @format int64 */
  id?: number
  smallURL?: string
  bigURL?: string
}

export interface AgentPreparePostDocumentUploadInput {
  /** @format int64 */
  postID?: number
}

export interface AgentPreparePostDocumentUploadOutput {
  upload?: AgentGetUploadLinkOutput
  filename?: string
}

export interface AgentPreparePostPhotoUploadInput {
  /** @format int64 */
  postID?: number
}

export interface AgentPreparePostPhotoUploadOutput {
  upload?: AgentGetUploadLinkOutput
  filename?: string
}

export interface AgentPriceRange {
  /** @format double */
  first?: number
  /** @format double */
  last?: number
  /** @format double */
  delta?: number
  /** @format double */
  deltaPercent?: number
}

export interface AgentProject {
  /** @format int64 */
  id?: number
  /** @format int64 */
  priority?: number
  token?: string
  /** @format int64 */
  scale?: number
  displayName?: string
  description?: string
  kind?: string
  type?: string
  state?: string
  tradeStatus?: string
  location?: AgentProjectLocation
  /** [Optional] */
  geoLocation?: AgentProjectGeoLocation
  /** @format int64 */
  defaultPhotoID?: number
  logoURL?: string
  /** [Optional] */
  photos?: AgentPostPhoto[]
  /** [Optional] */
  documents?: AgentPostDocument[]
  /** [Optional] */
  details?: AgentDetailedData[]
  market?: AgentProjectMarketDetails
  price?: AgentProjectPriceDetails
  circulation?: AgentProjectCirculationDetails
  createdAt?: string
}

export interface AgentProjectAgentLink {
  /** @format int64 */
  agentID?: number
  /** @format int64 */
  projectID?: number
  discount?: AgentAgentDiscount
  status?: 'wait_for_review' | 'accepted' | 'rejected'
  active?: boolean
  createdAt?: string
  updatedAt?: string
}

export interface AgentProjectCirculationDetails {
  /** @format int64 */
  otcBuy?: number
  /** @format int64 */
  otcSell?: number
  /** @format int64 */
  otcCirculating?: number
}

export interface AgentProjectGeoLocation {
  /** @format double */
  latitude?: number
  /** @format double */
  longitude?: number
}

export interface AgentProjectLocation {
  province?: AgentProvince
  county?: AgentCounty
  city?: AgentCity
  district?: AgentDistrict
  rural?: AgentRural
}

export interface AgentProjectMarketDetails {
  /** @format int64 */
  maxSupply?: number
  /** @format int64 */
  totalSupply?: number
  /** @format int64 */
  releaseDate?: number
  /** @format int64 */
  listingDate?: number
  /** @format int64 */
  minOrderSize?: number
}

export interface AgentProjectPriceDetails {
  /** @format double */
  volume24h?: number
  /** @format double */
  marketCap?: number
  /** @format double */
  fullyDilutedMarketCap?: number
  /** @format double */
  circulatingCap?: number
  priceRange24h?: AgentPriceRange
  priceRange7d?: AgentPriceRange
  priceRange30d?: AgentPriceRange
}

export interface AgentProvince {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface AgentReferralCode {
  code?: string
  createdAt?: string
}

export interface AgentRefreshTokenInput {
  refreshToken?: string
}

export interface AgentRefreshTokenOutput {
  accessToken?: string
  refreshToken?: string
}

export interface AgentRegisterByEmailInput {
  email?: string
  /** @format int64 */
  otp?: number
  code?: string
  referralCode?: string
}

export interface AgentRegisterByEmailOutput {
  userID?: string
  accessToken?: string
  refreshToken?: string
}

export interface AgentRegisterByPhoneInput {
  phone?: string
  /** @format int64 */
  otp?: number
  code?: string
  referralCode?: string
}

export interface AgentRegisterByPhoneOutput {
  userID?: string
  accessToken?: string
  refreshToken?: string
}

export interface AgentResendOTPInput {
  /** @format int64 */
  otp?: number
  /** [Optional] */
  email?: string
  /** [Optional] */
  phone?: string
}

export interface AgentResendOTPOutput {
  success?: boolean
}

export interface AgentRural {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface AgentSetDefaultBankAccountInput {
  /** @format int64 */
  bankID?: number
}

export interface AgentSetDefaultBankAccountOutput {
  bankAccount?: AgentBankAccount
}

export interface AgentSetPasswordSettingsInput {
  /** @format base64 */
  passwordHash?: string
  hint?: string
}

export interface AgentSetPasswordSettingsOutput {
  success?: boolean
}

export interface AgentSetProfileInput {
  /** [Optional] */
  displayName?: string
  /** [Optional] */
  instagram?: string
  /** [Optional] */
  telegram?: string
  /** [Optional] */
  whatsapp?: string
  /** [Optional] */
  info?: AgentAgentInfo
}

export interface AgentSetProfileOutput {
  success?: boolean
}

export interface AgentSetUserEmailInput {
  email?: string
  /** @format int64 */
  otp?: number
  code?: string
}

export interface AgentSetUserPhoneInput {
  phone?: string
  /** @format int64 */
  otp?: number
  code?: string
}

export interface AgentSetUsernameInput {
  username?: string
}

export interface AgentSocial {
  platform?: string
  link?: string
}

export interface AgentStartAgentKYCOutput {
  workflowID?: string
  uploadLink?: string
  /** [Optional] */
  formData?: Record<string, string>
  namePrefix?: string
}

export interface AgentTogglePostStatusInput {
  /** @format int64 */
  postID?: number
  published?: boolean
}

export interface AgentTogglePostStatusOutput {
  post?: AgentPost
}

export interface AgentToggleProjectAgentLinkActiveOutput {
  link?: AgentProjectAgentLink
}

export interface AgentToggleProjectLinkActiveInput {
  token?: string
  active?: boolean
}

export interface AgentUploadPostDocumentOutput {
  /** @format int64 */
  docID?: number
  document?: AgentUploadedDocument
  thumbnail?: AgentUploadedDocument
}

export interface AgentUploadPostPhotoOutput {
  /** @format int64 */
  photoID?: number
  resized?: AgentUploadedDocument
  thumbnail?: AgentUploadedDocument
}

export interface AgentUploadedDocument {
  /** @format int64 */
  id?: number
  name?: string
}

export interface AgentUser {
  /** @format int64 */
  id?: number
  userType?: string
  uuid?: string
  username?: string
  email?: string
  phone?: string
  nationalID?: string
  details?: AgentDetails
  joined?: string
  /** [Optional] */
  deletedAt?: string
  /** [Optional] */
  data?: AgentData[]
}

export interface AgentUserFinDetails {
  /** @format int64 */
  feeLevel?: number
}

export interface AgentUserKYC {
  status?: 'waiting_for_review' | 'under_review' | 'approved' | 'rejected'
  /** @format int64 */
  level?: number
  comment?: string
  /** [Optional] */
  ''?: Record<string, string>
}

export interface AgentUserMessage {
  /** @format int64 */
  id?: number
  /** @format int64 */
  userID?: number
  type?: 'security' | 'system' | 'announcement' | 'otc' | 'payment'
  createdAt?: string
  body?: AgentMessageBody
  meta?: AgentMessageMeta
  /** [Optional] */
  readAt?: string
}

export interface AgentUserPhoto {
  smallURL?: string
  largeURL?: string
}

export interface AgentUserReferral {
  /** @format int64 */
  userID?: number
  userType?: 'user' | 'agent'
  code?: string
  uuid?: string
}

export interface AgentUserSocial {
  platform?: string
  link?: string
}

export interface AgentUserSocials {
  /** [Optional] */
  platforms?: AgentUserSocial[]
}

export interface AgentVerifyPostDocumentUploadInput {
  /** @format int64 */
  postID?: number
  bucket?: string
  fileName?: string
  title?: string
  subtitle?: string
  description?: string
}

export interface AgentVerifyPostDocumentUploadOutput {
  docURL?: string
  thumbURL?: string
}

export interface AgentVerifyPostPhotoUploadInput {
  /** @format int64 */
  postID?: number
  bucket?: string
  fileName?: string
}

export interface AgentVerifyPostPhotoUploadOutput {
  smallURL?: string
  bigURL?: string
}

export type AgentVerifyUserTokenInput = object

export interface AgentWalletPortfolioChartData {
  /** @format int64 */
  time?: number
  /** @format int64 */
  balance?: number
  /** @format int64 */
  availableBalance?: number
  /** @format int64 */
  count?: number
}

export interface AgentWithdrawFiatInput {
  /** @format int64 */
  amount?: number
  currency?: string
  reference?: string
  /** @format int64 */
  bankID?: number
}

export interface AgentWithdrawFiatOutput {
  transaction?: AgentFiatTransaction
}

export interface FileDownloadInput {
  path?: string
}

export interface HealthError {
  /** @format int64 */
  code?: number
  codeName?: string
  item?: string
  ''?: string
}

export type HealthHealthInput = object

export interface HealthHealthOutput {
  ok?: boolean
}

export interface UserAccountPassword {
  hasPassword?: boolean
  hint?: string
  algorithmData?: UserAlgorithmV6AData
  /** @format base64 */
  srpB?: string
  /** @format base64 */
  randomData?: string
}

export interface UserAccountPortfolio {
  type?: 'fiat' | 'crypto' | 'asset' | 'project'
  currency?: string
  /** @format int64 */
  balance?: number
  /** @format int64 */
  availableBalance?: number
  /** @format int64 */
  estimatedBalance?: number
  /** @format int64 */
  estimatedAvailableBalance?: number
  delta24H?: UserPortfolioDelta
  delta7D?: UserPortfolioDelta
  delta30D?: UserPortfolioDelta
}

export interface UserAddUserBankAccountInput {
  type?: 'card' | 'iban'
  value?: string
  /** [Optional] */
  labels?: Record<string, string>
  addIBAN?: boolean
}

export interface UserAddUserBankAccountOutput {
  bankAccount?: UserUserBankAccount
}

export interface UserAddVideoDocumentInput {
  workflowID?: string
  name?: string
  contentType?: string
  /** [Optional] */
  meta?: Record<string, string>
}

export interface UserAgencyInfo {
  name?: string
  address?: string
}

export interface UserAgent {
  /** @format int64 */
  id?: number
  uuid?: string
  username?: string
  joined?: string
  /** [Optional] */
  details?: UserAgentDetails
}

export interface UserAgentCoverPhoto {
  url?: string
}

export interface UserAgentDetails {
  displayName?: string
  /** [Optional] */
  photo?: UserAgentPhoto
  /** [Optional] */
  cover?: UserAgentCoverPhoto
  /** [Optional] */
  socials?: UserUserSocials
  /** [Optional] */
  agency?: UserAgencyInfo
}

export interface UserAgentDiscount {
  type?: 'percentage' | 'fixed'
  /** @format double */
  value?: number
}

export interface UserAgentInfo {
  agencyName?: string
  agencyAddress?: string
}

export interface UserAgentPhoto {
  smallURL?: string
  largeURL?: string
}

export interface UserAlgorithmV6AData {
  /** @format base64 */
  salt1?: string
  /** @format base64 */
  salt2?: string
  /** @format int64 */
  g?: number
  /** @format base64 */
  p?: string
}

export interface UserAuthorDetails {
  firstName?: string
  lastName?: string
  displayName?: string
  /** [Optional] */
  photo?: UserUserPhoto
  /** [Optional] */
  socials?: UserSocial[]
  /** [Optional] */
  agency?: UserAgencyInfo
}

export interface UserBirthdate {
  /** @format int64 */
  year?: number
  /** @format int64 */
  month?: number
  /** @format int64 */
  day?: number
}

export interface UserBlockchain {
  name?: string
  requiresTag?: boolean
}

export interface UserCalculateFiatDepositCostInput {
  /** @format int64 */
  amount?: number
  currency?: string
}

export interface UserCalculateFiatDepositCostOutput {
  /** @format int64 */
  amount?: number
  /** @format int64 */
  charge?: number
  /** @format int64 */
  netAmount?: number
  /** @format int64 */
  grossAmount?: number
  currency?: string
}

export interface UserCalculateWithdrawalCostInput {
  /** @format int64 */
  amount?: number
  currency?: string
}

export interface UserCalculateWithdrawalCostOutput {
  /** @format int64 */
  amount?: number
  /** @format int64 */
  charge?: number
  /** @format int64 */
  netAmount?: number
  /** @format int64 */
  grossAmount?: number
  currency?: string
}

export interface UserCancelFiatWithdrawalInput {
  /** @format int64 */
  transactionID?: number
  comment?: string
}

export interface UserCancelFiatWithdrawalOutput {
  transaction?: UserFiatTransaction
}

export interface UserCheckBuyoutEligibilityInput {
  token?: string
}

export interface UserCheckBuyoutEligibilityOutput {
  /** @format int64 */
  yours?: number
  /** @format int64 */
  total?: number
  /** @format int64 */
  bought?: number
  /** @format int64 */
  available?: number
  eligible?: boolean
}

export interface UserCheckUserInput {
  /** [Optional] */
  phone?: string
  /** [Optional] */
  email?: string
}

export interface UserCheckUserOutput {
  exists?: boolean
  hasPassword?: boolean
  /** [Optional] */
  accountPassword?: UserAccountPassword
}

export interface UserCity {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface UserCounty {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface UserCoverPhoto {
  url?: string
}

export interface UserCreateEmailOTPInput {
  email?: string
}

export interface UserCreateOTPInput {
  phone?: string
}

export interface UserCreateOTPOutput {
  /** @format int64 */
  otp?: number
  /** @format int64 */
  digits?: number
}

export interface UserData {
  cat?: string
  subCat?: string
  /** @format base64 */
  data?: string
}

export interface UserDeleteUserBankAccountsInput {
  /** [Optional] */
  ids?: number[]
}

export interface UserDeleteUserBankAccountsOutput {
  /** [Optional] */
  bankAccounts?: UserUserBankAccount[]
}

export interface UserDetailedData {
  key?: string
  /** @format base64 */
  value?: string
  valueType?: 'string' | 'number' | 'boolean' | 'array' | 'object'
  /** [Optional] */
  annotations?: UserDetailedDataAnnotations[]
}

export interface UserDetailedDataAnnotations {
  key?: string
  value?: string
}

export interface UserDetails {
  firstName?: string
  lastName?: string
  displayName?: string
  birthDate?: string
  /** [Optional] */
  kyc?: UserUserKYC
  /** [Optional] */
  photo?: UserUserPhoto
  /** [Optional] */
  coverPhoto?: UserCoverPhoto
  /** [Optional] */
  finDetails?: UserUserFinDetails
  /** [Optional] */
  referral?: UserUserReferral
  /** [Optional] */
  socials?: UserUserSocials
  /** [Optional] */
  agentInfo?: UserAgentInfo
}

export interface UserDistrict {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface UserError {
  /** @format int64 */
  code?: number
  codeName?: string
  item?: string
  ''?: string
}

export interface UserFeeLevel {
  /** @format double */
  fee?: number
  /** @format int64 */
  min?: number
  /** @format int64 */
  max?: number
}

export interface UserFiatDeposit {
  provider?: string
  final?: boolean
  reference?: string
  sessionID?: string
  type?: string
}

export interface UserFiatRefund {
  reference?: string
  /** @format int64 */
  originalTxn?: number
}

export interface UserFiatTransaction {
  /** @format int64 */
  id?: number
  /** @format int64 */
  userID?: number
  /** @format int64 */
  amount?: number
  /** @format int64 */
  effectiveAmount?: number
  currency?: string
  status?: 'completed' | 'pending' | 'failed' | 'canceled' | 'rejected'
  createdAt?: string
  updatedAt?: string
  /** [Optional] */
  deposit?: UserFiatDeposit
  /** [Optional] */
  withdrawal?: UserFiatWithdrawal
  /** [Optional] */
  refund?: UserFiatRefund
  comment?: string
}

export interface UserFiatWithdrawInput {
  /** @format int64 */
  amount?: number
  currency?: string
  reference?: string
  /** @format int64 */
  bankID?: number
}

export interface UserFiatWithdrawOutput {
  transaction?: UserFiatTransaction
}

export interface UserFiatWithdrawal {
  /** @format int64 */
  reference?: number
  iban?: string
}

export interface UserFinalizeConvertOrderOutput {
  /** [Optional] */
  transactions?: UserOTCTransaction[]
}

export interface UserFlag {
  /** [Optional] */
  ''?: string
  reason?: string
}

export interface UserGatewayProvider {
  name?: string
}

export interface UserGetAgentByUsernameInput {
  username?: string
}

export interface UserGetAgentInput {
  uuid?: string
}

export interface UserGetAgentOutput {
  agent?: UserAgent
}

export interface UserGetAvailableCryptoContractsInput {
  direction?: string
}

export interface UserGetAvailableCryptoContractsOutput {
  /** [Optional] */
  contracts?: UserTokenContract[]
}

export type UserGetAvailableGatewaysInput = object

export interface UserGetAvailableGatewaysOutput {
  /** [Optional] */
  providers?: UserGatewayProvider[]
}

export interface UserGetCitiesRequest {
  /** @format int64 */
  countyID?: number
  /** @format int64 */
  provinceID?: number
}

export interface UserGetCitiesResponse {
  /** [Optional] */
  cities?: UserCity[]
}

export interface UserGetConvertRateInput {
  fromCurrency?: string
  toCurrency?: string
}

export interface UserGetConvertRateOutput {
  /** @format double */
  rate?: number
  /** @format int64 */
  fromAvailableBalance?: number
  /** @format int64 */
  fromMaxAmount?: number
  /** @format int64 */
  fromScale?: number
  /** @format int64 */
  expireAt?: number
}

export interface UserGetCountiesRequest {
  /** @format int64 */
  provinceID?: number
}

export interface UserGetCountiesResponse {
  /** [Optional] */
  counties?: UserCounty[]
}

export interface UserGetDistrictsRequest {
  /** @format int64 */
  countyID?: number
  /** @format int64 */
  provinceID?: number
  /**
   * [Optional]
   * @format int64
   */
  cityID?: number
}

export interface UserGetDistrictsResponse {
  /** [Optional] */
  districts?: UserDistrict[]
}

export type UserGetFeatureFlagsInput = object

export interface UserGetFeatureFlagsOutput {
  /** [Optional] */
  flags?: Record<string, UserFlag>
}

export interface UserGetFiatTransactionHistoryInput {
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
  /** [Optional] */
  currency?: string
  deposits?: boolean
  withdrawals?: boolean
}

export interface UserGetFiatTransactionHistoryOutput {
  /** [Optional] */
  transactions?: UserFiatTransaction[]
  /** [Optional] */
  ledgers?: UserLedger[]
}

export interface UserGetHistoryInput {
  /** @format int64 */
  userID?: number
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface UserGetHistoryOutput {
  /** [Optional] */
  transactions?: UserTransaction[]
  /** [Optional] */
  missions?: UserUserMission[]
}

export type UserGetLoyaltyMissionsInput = object

export type UserGetLoyaltyPortfolioInput = object

export interface UserGetManyProjectsOutput {
  /** [Optional] */
  projects?: UserProject[]
}

export type UserGetMarketPerformanceInput = object

export interface UserGetMarketPricePerformanceOutput {
  /** [Optional] */
  newest?: UserPricePerformance[]
  /** [Optional] */
  worst?: UserPricePerformance[]
  /** [Optional] */
  bests?: UserPricePerformance[]
  /** [Optional] */
  projects?: UserProject[]
}

export interface UserGetMissionsOutput {
  /** [Optional] */
  missions?: UserUserMission[]
}

export interface UserGetOTCHistoryOutput {
  /** [Optional] */
  transactions?: UserOTCTransaction[]
  /** [Optional] */
  users?: UserUser[]
}

export interface UserGetOTCPriceInput {
  symbol?: string
  base?: string
  orderType?: 'buy' | 'sell'
}

export type UserGetPasswordSettingsInput = object

export interface UserGetPasswordSettingsOutput {
  algorithmData?: UserAlgorithmV6AData
  hint?: string
  /** @format base64 */
  srpHash?: string
}

export interface UserGetPortfolioChartInput {
  /** [Optional] */
  currency?: string
  period?: '1h' | '1d' | '1w' | '1M'
}

export interface UserGetPortfolioChartOutput {
  /** [Optional] */
  data?: UserPortfolioChartData[]
  /** [Optional] */
  ledgers?: UserLedger[]
}

export interface UserGetPortfolioOutput {
  portfolio?: UserPortfolio
}

export interface UserGetPriceChartOutput {
  /** [Optional] */
  data?: UserSymbolPairPrice[]
}

export interface UserGetPriceOutput {
  /** @format double */
  price?: number
  /** @format int64 */
  baseAvailableBalance?: number
  /** @format int64 */
  baseMaxAmount?: number
  /** @format int64 */
  baseScale?: number
  /** @format int64 */
  targetAvailableBalance?: number
  /** @format int64 */
  targetMaxAmount?: number
  /** @format int64 */
  targetScale?: number
}

export interface UserGetPricePerformanceInput {
  /** [Optional] */
  symbols?: string[]
  base?: string
  period?: '1m' | '5m' | '1h' | '1d' | '7d' | '30d'
}

export interface UserGetPricePerformanceOutput {
  /** [Optional] */
  prices?: UserPricePerformance[]
}

export interface UserGetProjectCertInput {
  token?: string
}

export interface UserGetProjectCertOutput {
  project?: UserProject
  /** [Optional] */
  ownership?: UserProjectOwnershipDetails
}

export interface UserGetProjectInput {
  token?: string
}

export interface UserGetProjectOutput {
  project?: UserProject
}

export interface UserGetProjectPriceChartInput {
  token?: string
  period?: '30d' | '90d' | '1y' | '5y'
}

export interface UserGetProjectPriceChartSnapshotInput {
  token?: string
}

export type UserGetProvincesRequest = object

export interface UserGetProvincesResponse {
  /** [Optional] */
  provinces?: UserProvince[]
}

export interface UserGetRecentlyVisitedOutput {
  /** [Optional] */
  projects?: UserProject[]
}

export interface UserGetRecentlyVisitedProjectsInput {
  /** @format int64 */
  limit?: number
}

export type UserGetReferralCodesInput = object

export interface UserGetReferralCodesOutput {
  /** [Optional] */
  codes?: UserReferralCode[]
}

export type UserGetUserBankAccountsInput = object

export interface UserGetUserBankAccountsOutput {
  /** [Optional] */
  bankAccounts?: UserUserBankAccount[]
}

export type UserGetUserFiatPortfolioInput = object

export type UserGetUserPerformanceInput = object

export interface UserGetUserPerformanceOutput {
  /** @format int64 */
  otcVolume?: number
  otcVolumeCurrency?: string
  /** @format double */
  otcFee?: number
  /** @format int64 */
  untilNextLevel?: number
  /** @format double */
  nextLevelFee?: number
  /** [Optional] */
  levels?: UserFeeLevel[]
}

export interface UserGetUserPortfolioOutput {
  /** [Optional] */
  accounts?: UserAccountPortfolio[]
  estimated?: UserAccountPortfolio
  /** [Optional] */
  ledgers?: UserLedger[]
  /** [Optional] */
  projects?: UserProject[]
}

export interface UserGetWalletPortfolioChartInput {
  orgCurrency?: string
  /** [Optional] */
  currency?: string
  period?: '1h' | '1d' | '1w' | '1M'
}

export interface UserGetWalletPortfolioChartOutput {
  /** [Optional] */
  data?: UserWalletPortfolioChartData[]
  /** [Optional] */
  ledgers?: UserLedger[]
}

export interface UserInboxListMessagesOutput {
  /** [Optional] */
  messages?: UserUserMessage[]
}

export interface UserInboxMarkAllAsReadOutput {
  success?: boolean
}

export interface UserInboxMarkAllReadInput {
  until?: string
}

export interface UserInboxMarkAsReadOutput {
  success?: boolean
}

export interface UserInboxMarkReadInput {
  /** @format int64 */
  msgID?: number
}

export interface UserInitiateCryptoDepositInput {
  blockchain?: string
  token?: string
}

export interface UserInitiateCryptoDepositOutput {
  address?: string
  destinationTag?: string
}

export interface UserKYCDocument {
  /** @format int64 */
  id?: number
  name?: string
  bucket?: string
  contentType?: string
  /** [Optional] */
  meta?: Record<string, string>
  /** @format int64 */
  size?: number
}

export interface UserLedger {
  /** @format int64 */
  id?: number
  name?: string
  /** @format int64 */
  scale?: number
  /** [Optional] */
  ''?: Record<string, string>
}

export interface UserListAgentPostsInput {
  agentUUID?: string
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface UserListPostsOutput {
  /** @format int64 */
  total?: number
  /** [Optional] */
  posts?: UserPost[]
  /** [Optional] */
  projects?: UserProject[]
  /** [Optional] */
  authors?: UserPostAuthor[]
  /** [Optional] */
  links?: UserProjectAgentLink[]
}

export interface UserListProjectPostsInput {
  token?: string
}

export interface UserListProjectsInput {
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
  /** [Optional] */
  q?: string
  /** [Optional] */
  kind?: 'property' | 'crypto'
  /** [Optional] */
  type?:
    | 'residential'
    | 'commercial'
    | 'office'
    | 'touristic'
    | 'industrial'
    | 'agricultural'
    | 'mining'
    | 'transportation'
    | 'other'
    | 'land'
  /** [Optional] */
  state?:
    | 'planning'
    | 'under_construction'
    | 'completed'
    | 'occupied'
    | 'for_sale'
    | 'for_rent'
    | 'other'
  /** [Optional] */
  tradeStatus?:
    | 'active'
    | 'suspended'
    | 'delisting'
    | 'coming_soon'
    | 'off_market'
  /**
   * [Optional]
   * @format int64
   */
  provinceID?: number
  /**
   * [Optional]
   * @format int64
   */
  countyID?: number
  /**
   * [Optional]
   * @format int64
   */
  cityID?: number
  /**
   * [Optional]
   * @format int64
   */
  districtID?: number
  /** [Optional] */
  orderBy?: 'expensive' | 'cheapest' | 'gainer' | 'loser' | 'newest'
  /**
   * [Optional]
   * @format int64
   */
  priceMin?: number
  /**
   * [Optional]
   * @format int64
   */
  priceMax?: number
  /** [Optional] */
  excludeIDs?: number[]
}

export interface UserListProjectsOutput {
  /** @format int64 */
  total?: number
  /** [Optional] */
  projects?: UserProject[]
}

export interface UserListReferralsInput {
  /**
   * [Optional]
   * @format int64
   */
  userID?: number
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface UserListReferralsOutput {
  /** @format int64 */
  total?: number
  /** [Optional] */
  referrals?: UserReferralStats[]
}

export interface UserListUserActivitiesInput {
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
  /** @format int64 */
  fromTimeUnix?: number
  /** @format int64 */
  toTimeUnix?: number
}

export interface UserListUserActivitiesOutput {
  /** [Optional] */
  activities?: UserUserActivity[]
}

export interface UserListUserAssetTransfersInput {
  /** [Optional] */
  currency?: string
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface UserListUserAssetTransfersOutput {
  /** [Optional] */
  transfers?: UserUserAssetTransfer[]
}

export interface UserLoginByEmailInput {
  email?: string
  /** @format int64 */
  otp?: number
  code?: string
}

export interface UserLoginByEmailOutput {
  userID?: string
  accessToken?: string
  refreshToken?: string
}

export interface UserLoginByPasswordInput {
  /** [Optional] */
  phone?: string
  /** [Optional] */
  email?: string
  /** @format base64 */
  a?: string
  /** @format base64 */
  m1?: string
}

export interface UserLoginByPasswordOutput {
  userID?: string
  accessToken?: string
  refreshToken?: string
}

export interface UserLoginByPhoneInput {
  phone?: string
  /** @format int64 */
  otp?: number
  code?: string
}

export interface UserLoginByPhoneOutput {
  userID?: string
  accessToken?: string
  refreshToken?: string
}

export interface UserMarketPerformance {
  /** [Optional] */
  bests?: UserPricePerformance[]
  /** [Optional] */
  worst?: UserPricePerformance[]
  /** [Optional] */
  newest?: UserPricePerformance[]
}

export interface UserMessageAction {
  key?: string
  url?: string
  expiresAt?: string
}

export interface UserMessageBody {
  format?: string
  /** [Optional] */
  args?: string[]
}

export interface UserMessageMeta {
  /** [Optional] */
  action?: UserMessageAction
}

export interface UserMission {
  /** @format int64 */
  id?: number
  name?: string
  /** @format int64 */
  points?: number
  defaultEnabled?: boolean
  data?: UserMissionData
}

export interface UserMissionData {
  milestone?: UserMissionMilestone
  dependency?: UserMissionDependency
}

export interface UserMissionDependency {
  /** [Optional] */
  missions?: string[]
}

export interface UserMissionMilestone {
  /** @format int64 */
  totalSteps?: number
}

export interface UserOTCConvertOrder {
  ID?: string
  buyOrder?: UserOTCOrder
  sellOrder?: UserOTCOrder
}

export interface UserOTCFinalizeConvertOrderInput {
  orderID?: string
}

export interface UserOTCGetHistoryInput {
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
  /** [Optional] */
  targetCurrency?: string
  /** [Optional] */
  baseCurrency?: string
}

export interface UserOTCOrder {
  id?: string
  /** @format int64 */
  userID?: number
  userType?: string
  /** [Optional] */
  referral?: UserOTCReferral
  baseCurrency?: string
  /** @format int64 */
  baseAmount?: number
  targetCurrency?: string
  /** @format int64 */
  targetAmount?: number
  orderType?: string
  /** [Optional] */
  charges?: UserOTCOrderCharge[]
  /** @format int64 */
  createdAt?: number
}

export interface UserOTCOrderCharge {
  currency?: string
  /** @format int64 */
  value?: number
  key?: string
  type?: string
  /** [Optional] */
  desc?: UserOrderChargeDesc
}

export interface UserOTCPayOrderInput {
  orderID?: string
}

export interface UserOTCPlaceConvertOrderInput {
  submit?: boolean
  fromCurrency?: string
  toCurrency?: string
  /** @format int64 */
  amount?: number
}

export interface UserOTCPlaceOrderInput {
  submit?: boolean
  targetCurrency?: string
  baseCurrency?: string
  orderType?: 'buy' | 'sell'
  amountCurrency?: string
  /** @format int64 */
  amount?: number
  referralCode?: string
  affiliateCode?: string
}

export interface UserOTCReferral {
  /** @format int64 */
  userID?: number
  userUUID?: string
  userType?: string
  name?: string
  /** [Optional] */
  photo?: UserOTCReferralPhoto
  discountCode?: string
  dismissable?: boolean
}

export interface UserOTCReferralPhoto {
  smallUrl?: string
  largeUrl?: string
}

export interface UserOTCTransaction {
  /** @format int64 */
  id?: number
  /** @format int64 */
  userID?: number
  userType?: string
  /**
   * [Optional]
   * @format int64
   */
  agentID?: number
  /**
   * [Optional]
   * @format int64
   */
  agentAmount?: number
  baseCurrency?: string
  /** @format int64 */
  baseAmount?: number
  targetCurrency?: string
  /** @format int64 */
  targetAmount?: number
  order?: UserOTCOrder
  createdAt?: string
}

export interface UserOrderChargeDesc {
  title?: string
  /** @format double */
  value?: number
  valueType?: 'percent' | 'fixed'
}

export interface UserPayOrderOutput {
  transaction?: UserOTCTransaction
}

export interface UserPaymentInitiateFiatDepositInput {
  provider?: 'saman' | 'vandar'
  /** @format int64 */
  amount?: number
  currency?: string
  successURL?: string
  failureURL?: string
  reference?: string
  /** @format int64 */
  bankID?: number
}

export interface UserPaymentInitiateFiatDepositOutput {
  redirectURL?: string
  sessionID?: string
}

export interface UserPaymentVerifyFiatDepositInput {
  sessionID?: string
}

export interface UserPaymentVerifyFiatDepositOutput {
  status?: 'pending' | 'success' | 'failed'
  final?: boolean
  accepted?: boolean
  /** @format int64 */
  amount?: number
  currency?: string
}

export interface UserPlaceConvertOrderOutput {
  order?: UserOTCConvertOrder
  expireAt?: string
}

export interface UserPlaceOTCOrderOutput {
  order?: UserOTCOrder
  expireAt?: string
}

export interface UserPortfolio {
  /** @format int64 */
  balance?: number
  estimatedCurrency?: string
  /** @format int64 */
  estimatedBalance?: number
  /** @format double */
  coefficient?: number
  level?: UserPortfolioLevel
  referrals?: UserPortfolioReferrals
  stats?: UserPortfolioStats
}

export interface UserPortfolioChartData {
  /** @format int64 */
  time?: number
  /** @format int64 */
  balance?: number
  /** @format int64 */
  availableBalance?: number
  /** @format int64 */
  count?: number
}

export interface UserPortfolioDelta {
  /** @format double */
  percent?: number
  /** @format int64 */
  amount?: number
}

export interface UserPortfolioLevel {
  /** @format int64 */
  current?: number
  /** @format int64 */
  pointsToNext?: number
}

export interface UserPortfolioReferrals {
  /** @format int64 */
  totalInvites?: number
  /** @format int64 */
  directInvites?: number
}

export interface UserPortfolioStats {
  /** @format int64 */
  totalDirectEarned?: number
  /** @format int64 */
  totalIndirectEarned?: number
  /** @format int64 */
  totalEarned?: number
}

export interface UserPost {
  /** @format int64 */
  id?: number
  /** @format int64 */
  authorID?: number
  /** @format int64 */
  projectID?: number
  /**
   * [Optional]
   * @format int64
   */
  auditorID?: number
  text?: string
  /** [Optional] */
  audit?: UserPostAudit
  status?: string
  createdAt?: string
  updatedAt?: string
  /** @format int64 */
  edits?: number
  body?: string
  /** [Optional] */
  pros?: string[]
  /** [Optional] */
  cons?: string[]
  /** [Optional] */
  photos?: UserPostPhoto[]
  /** [Optional] */
  documents?: UserPostDocument[]
}

export interface UserPostAudit {
  /** @format int64 */
  auditorID?: number
  accepted?: boolean
  /** [Optional] */
  comments?: string[]
}

export interface UserPostAuthor {
  /** @format int64 */
  userID?: number
  userType?: string
  uuid?: string
  username?: string
  details?: UserAuthorDetails
  joined?: string
}

export interface UserPostDocument {
  /** @format int64 */
  id?: number
  docURL?: string
  thumbURL?: string
  title?: string
  subTitle?: string
  description?: string
}

export interface UserPostPhoto {
  /** @format int64 */
  id?: number
  smallURL?: string
  bigURL?: string
}

export interface UserPricePerformance {
  symbol?: string
  base?: string
  /** @format double */
  delta?: number
  /** @format double */
  deltaPercent?: number
  /** @format double */
  firstPrice?: number
  /** @format double */
  lastPrice?: number
}

export interface UserPriceRange {
  /** @format double */
  first?: number
  /** @format double */
  last?: number
  /** @format double */
  delta?: number
  /** @format double */
  deltaPercent?: number
}

export interface UserProject {
  /** @format int64 */
  id?: number
  /** @format int64 */
  priority?: number
  token?: string
  /** @format int64 */
  scale?: number
  displayName?: string
  description?: string
  kind?: string
  type?: string
  state?: string
  tradeStatus?: string
  location?: UserProjectLocation
  /** [Optional] */
  geoLocation?: UserProjectGeoLocation
  /** @format int64 */
  defaultPhotoID?: number
  logoURL?: string
  /** [Optional] */
  photos?: UserPostPhoto[]
  /** [Optional] */
  documents?: UserPostDocument[]
  /** [Optional] */
  details?: UserDetailedData[]
  market?: UserProjectMarketDetails
  price?: UserProjectPriceDetails
  circulation?: UserProjectCirculationDetails
  createdAt?: string
}

export interface UserProjectAgentLink {
  /** @format int64 */
  agentID?: number
  /** @format int64 */
  projectID?: number
  discount?: UserAgentDiscount
  status?: 'wait_for_review' | 'accepted' | 'rejected'
  active?: boolean
  createdAt?: string
  updatedAt?: string
}

export interface UserProjectCirculationDetails {
  /** @format int64 */
  otcBuy?: number
  /** @format int64 */
  otcSell?: number
  /** @format int64 */
  otcCirculating?: number
}

export interface UserProjectGeoLocation {
  /** @format double */
  latitude?: number
  /** @format double */
  longitude?: number
}

export interface UserProjectLocation {
  province?: UserProvince
  county?: UserCounty
  city?: UserCity
  district?: UserDistrict
  rural?: UserRural
}

export interface UserProjectMarketDetails {
  /** @format int64 */
  maxSupply?: number
  /** @format int64 */
  totalSupply?: number
  /** @format int64 */
  releaseDate?: number
  /** @format int64 */
  listingDate?: number
  /** @format int64 */
  minOrderSize?: number
}

export interface UserProjectOwnershipDetails {
  /** @format int64 */
  shares?: number
  /** @format double */
  value?: number
}

export interface UserProjectPriceDetails {
  /** @format double */
  volume24h?: number
  /** @format double */
  marketCap?: number
  /** @format double */
  fullyDilutedMarketCap?: number
  /** @format double */
  circulatingCap?: number
  priceRange24h?: UserPriceRange
  priceRange7d?: UserPriceRange
  priceRange30d?: UserPriceRange
}

export interface UserProvince {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface UserQuickKYCInput {
  nationalID?: string
  birthdate?: UserBirthdate
}

export interface UserQuickKYCOutput {
  verified?: boolean
}

export interface UserQuickKYCVerifyInput {
  nationalID?: string
  birthdate?: UserBirthdate
}

export interface UserQuickKYCVerifyOutput {
  verified?: boolean
  userExists?: boolean
  firstName?: string
  lastName?: string
}

export interface UserReferralCode {
  code?: string
  createdAt?: string
}

export interface UserReferralStats {
  /** @format int64 */
  userID?: number
  userType?: string
  joinedAt?: string
  maskedPhone?: string
  maskedEmail?: string
  /** @format int64 */
  trades?: number
  /** @format int64 */
  directInvites?: number
  /** @format int64 */
  totalInvites?: number
  /** @format int64 */
  totalDirectEarned?: number
  /** @format int64 */
  totalIndirectEarned?: number
  /** @format int64 */
  totalEarned?: number
  /** @format int64 */
  received?: number
  kyc?: boolean
  /** @format int64 */
  kycLevel?: number
  /** @format int64 */
  userLevel?: number
  /** @format int64 */
  balance?: number
}

export interface UserRefreshTokenInput {
  refreshToken?: string
}

export interface UserRefreshTokenOutput {
  accessToken?: string
  refreshToken?: string
}

export interface UserRegisterByEmailInput {
  email?: string
  /** @format int64 */
  otp?: number
  code?: string
  referralCode?: string
}

export interface UserRegisterByEmailOutput {
  userID?: string
  accessToken?: string
  refreshToken?: string
}

export interface UserRegisterByPhoneInput {
  phone?: string
  /** @format int64 */
  otp?: number
  code?: string
  referralCode?: string
}

export interface UserRegisterByPhoneOutput {
  userID?: string
  accessToken?: string
  refreshToken?: string
}

export interface UserResendOTPInput {
  /** @format int64 */
  otp?: number
  /** [Optional] */
  email?: string
  /** [Optional] */
  phone?: string
}

export interface UserResendOTPOutput {
  success?: boolean
}

export interface UserRural {
  /** @format int64 */
  id?: number
  name?: string
  slug?: string
}

export interface UserSetDefaultUserBankAccountInput {
  /** @format int64 */
  bankID?: number
}

export interface UserSetDefaultUserBankAccountOutput {
  bankAccount?: UserUserBankAccount
}

export interface UserSetPasswordSettingsInput {
  /** @format base64 */
  passwordHash?: string
  hint?: string
}

export interface UserSetPasswordSettingsOutput {
  success?: boolean
}

export interface UserSetUserDetailInput {
  /** [Optional] */
  firstName?: string
  /** [Optional] */
  lastName?: string
  /** [Optional] */
  birthDate?: string
  /** [Optional] */
  displayName?: string
}

export interface UserSetUserEmailInput {
  email?: string
  /** @format int64 */
  otp?: number
  code?: string
}

export interface UserSetUserPhoneInput {
  phone?: string
  /** @format int64 */
  otp?: number
  code?: string
}

export interface UserSocial {
  platform?: string
  link?: string
}

export interface UserStartVideoKYCOutput {
  workflowID?: string
  uploadLink?: string
  /** [Optional] */
  formData?: Record<string, string>
  name?: string
}

export interface UserSymbolPairPrice {
  /** @format int64 */
  time?: number
  targetCurrency?: string
  baseCurrency?: string
  /** @format int64 */
  count?: number
  /** @format double */
  price?: number
}

export interface UserTokenContract {
  currency?: string
  /** [Optional] */
  blockchains?: UserBlockchain[]
}

export interface UserTransaction {
  /** @format int64 */
  id?: number
  /** @format int64 */
  userID?: number
  /** @format int64 */
  amount?: number
  mission?: string
  /** @format double */
  coefficient?: number
  data?: UserTransactionData
  createdAt?: string
}

export interface UserTransactionData {
  /** @format int64 */
  fromUserID?: number
  fromMaskedPhone?: string
  fromMaskedEmail?: string
}

export interface UserUploadedDocument {
  /** @format int64 */
  id?: number
  name?: string
  bucket?: string
  contentType?: string
  /** [Optional] */
  meta?: Record<string, string>
  /** @format int64 */
  size?: number
}

export interface UserUser {
  /** @format int64 */
  id?: number
  userType?: string
  uuid?: string
  username?: string
  email?: string
  phone?: string
  nationalID?: string
  details?: UserDetails
  joined?: string
  /** [Optional] */
  deletedAt?: string
  /** [Optional] */
  data?: UserData[]
}

export interface UserUserActivity {
  /** @format int64 */
  id?: number
  /** @format int64 */
  userID?: number
  kind?: string
  /** @format base64 */
  payload?: string
  createdAt?: string
}

export interface UserUserAssetTransfer {
  /** @format int64 */
  id?: number
  createdAt?: string
  updatedAt?: string
  /** @format int64 */
  userID?: number
  /** @format int64 */
  peerUserID?: number
  currency?: string
  /** @format int64 */
  ticketID?: number
  /** @format int64 */
  credit?: number
  /** @format int64 */
  debit?: number
  status?: 'pending' | 'completed' | 'rejected' | 'cancelled'
  details?: UserUserAssetTransferDetails
}

export interface UserUserAssetTransferDetails {
  maskedPeerPhone?: string
  maskedPeerEmail?: string
}

export interface UserUserAssetTransferInput {
  /** [Optional] */
  destinationPhone?: string
  /** [Optional] */
  destinationEmail?: string
  currency?: string
  /** @format int64 */
  amount?: number
  preview?: boolean
}

export interface UserUserAssetTransferOutput {
  transferID?: string
  /** @format int64 */
  ticketID?: number
  /** @format int64 */
  estimatedValue?: number
  estimatedValueCurrency?: string
  /** @format int64 */
  fee?: number
  feeCurrency?: string
}

export interface UserUserBankAccount {
  /** @format int64 */
  id?: number
  type?: string
  data?: string
  default?: boolean
  details?: UserUserBankDetails
  /** [Optional] */
  labels?: Record<string, string>
  createdAt?: string
}

export interface UserUserBankDetails {
  /** [Optional] */
  owners?: UserUserBankOwner[]
  iban?: string
  bankName?: string
  accountNumber?: string
}

export interface UserUserBankOwner {
  firstName?: string
  lastName?: string
  nationalID?: string
}

export interface UserUserFinDetails {
  /** @format int64 */
  feeLevel?: number
}

export interface UserUserInboxListMessagesInput {
  /** [Optional] */
  messageType?: 'security' | 'system' | 'announcement' | 'otc' | 'payment'
  /** @format int64 */
  skip?: number
  /** @format int64 */
  limit?: number
}

export interface UserUserKYC {
  status?: 'waiting_for_review' | 'under_review' | 'approved' | 'rejected'
  /** @format int64 */
  level?: number
  comment?: string
  /** [Optional] */
  ''?: Record<string, string>
}

export interface UserUserMessage {
  /** @format int64 */
  id?: number
  /** @format int64 */
  userID?: number
  type?: 'security' | 'system' | 'announcement' | 'otc' | 'payment'
  createdAt?: string
  body?: UserMessageBody
  meta?: UserMessageMeta
  /** [Optional] */
  readAt?: string
}

export interface UserUserMission {
  mission?: UserMission
  enabled?: boolean
  status?: 'started' | 'completed' | 'expired'
  milestone?: UserUserMissionMilestone
}

export interface UserUserMissionMilestone {
  /** @format int64 */
  completedSteps?: number
  /** @format int64 */
  receivedPoints?: number
}

export interface UserUserPhoto {
  smallURL?: string
  largeURL?: string
}

export interface UserUserReferral {
  /** @format int64 */
  userID?: number
  userType?: 'user' | 'agent'
  code?: string
  uuid?: string
}

export interface UserUserSocial {
  platform?: string
  link?: string
}

export interface UserUserSocials {
  /** [Optional] */
  platforms?: UserUserSocial[]
}

export type UserVerifyUserTokenInput = object

export interface UserVideoKYCStartInput {
  firstName?: string
  lastName?: string
  nationalID?: string
  birthdate?: UserBirthdate
}

export interface UserWalletPortfolioChartData {
  /** @format int64 */
  time?: number
  /** @format int64 */
  balance?: number
  /** @format int64 */
  availableBalance?: number
  /** @format int64 */
  count?: number
}

export interface UserWebhookInput {
  method?: string
  provider?: string
  param1?: string
  param2?: string
  /** @format base64 */
  body?: string
  /** [Optional] */
  header?: Record<string, string>[]
  /** [Optional] */
  queryParams?: Record<string, string>
}

export interface AdminGetAccountParams {
  id: number
}

export interface AdminGetAccountByEmailParams {
  email: string
}

export interface AdminGetAccountByPhoneParams {
  phone: string
}

export interface AdminListAccountsParams {
  type: string
  page: number
  pageSize: number
}

export interface AdminListAgentKyCsParams {
  userID?: number
  status?: number
  skip: number
  limit: number
}

export interface AdminListVideoKyCsParams {
  userID?: number
  status?: number
  skip: number
  limit: number
}

export interface AdminGetLiquidityAccountsParams {
  account: 'otc' | 'fiat' | 'loyalty'
}

export interface AdminListTransferTicketsParams {
  from?: string
  to?: string
  skip: number
  limit: number
  transferType?:
    | 'between_users'
    | 'deposit_bank'
    | 'card_to_card'
    | 'withdrawal'
  userID?: number
  iban?: string
  card?: string
}

export interface AdminDeleteLocationParams {
  id: number
}

export interface AdminGetMissionsParams {
  userID: number
}

export interface AdminListFiatTransactionsParams {
  skip: number
  limit: number
  deposits: boolean
  withdrawals: boolean
  userID?: number
  currency?: string
  status?: 'completed' | 'pending' | 'failed' | 'canceled'
}

export interface AdminListProjectAgentLinksParams {
  projectID?: number
  status?: 'wait_for_review' | 'accepted' | 'rejected'
  skip: number
  limit: number
}

export interface AdminGetProjectAgentLinksParams {
  onlyActives: boolean
  skip: number
  limit: number
  userId: number
}

export interface AdminDeleteProjectLogoParams {
  projectID: number
}

export interface AdminDeleteProjectPostParams {
  postID: number
}

export interface AdminListProjectPostsParams {
  projectID?: any[]
  authorID?: any[]
  auditorID?: any[]
  status?: 'in_review' | 'published' | 'accepted' | 'rejected' | 'draft'
  skip: number
  limit: number
}

export interface AdminGetProjectPriceExprParams {
  projectID: number
}

export interface AdminDeleteProjectDocumentParams {
  projectId: number
  documentId: number
}

export interface AdminDeleteProjectPhotoParams {
  projectId: number
  photoId: number
}

export interface AdminGetProjectParams {
  userID?: number
  token: string
}

export interface AdminSetProjectMarketDetailsParams {
  token: string
}

export interface AdminListProjectsParams {
  skip: number
  limit: number
  q?: string
  kind?: 'property' | 'crypto'
  type?:
    | 'residential'
    | 'commercial'
    | 'office'
    | 'touristic'
    | 'industrial'
    | 'agricultural'
    | 'mining'
    | 'transportation'
    | 'other'
    | 'land'
  state?:
    | 'planning'
    | 'under_construction'
    | 'completed'
    | 'occupied'
    | 'for_sale'
    | 'for_rent'
    | 'other'
  tradeStatus?:
    | 'active'
    | 'suspended'
    | 'delisting'
    | 'coming_soon'
    | 'off_market'
  provinceID?: number
  countyID?: number
  cityID?: number
  districtID?: number
  orderBy?: 'expensive' | 'cheapest' | 'gainer' | 'loser' | 'newest'
  priceMin?: number
  priceMax?: number
  excludeIDs?: any[]
}

export interface AdminGetUserParams {
  id: number
}

export interface AdminDeleteUserParams {
  userID: number
}

export interface AdminListUserBankAccountsParams {
  userID: number
}

export interface AdminGetUserByEmailParams {
  userType: 'user' | 'agent'
  email: string
}

export interface AdminListUsersParams {
  userType: 'user' | 'agent'
  skip: number
  limit: number
}

export interface AdminGetUserOtcHistoryParams {
  userID?: number
  agentID?: number
  skip: number
  limit: number
  targetCurrency?: string
  baseCurrency?: string
}

export interface AdminGetUserByPhoneParams {
  userType: 'user' | 'agent'
  phone: string
}

export interface AdminGetUserPortfolioParams {
  userID: number
  userType: string
  estimateCurrency: string
}

export interface AgentListAvailableProjectsParams {
  skip: number
  limit: number
  q?: string
  type?: string
  state?: string
  provinceID?: number
  countyID?: number
  cityID?: number
  districtID?: number
  orderBy?: string
  priceMin?: number
  priceMax?: number
}

export interface AgentDeleteBankAccountsParams {
  ids?: any[]
}

export interface AgentCheckParams {
  phone?: string
  email?: string
}

export interface AgentInboxListMessagesParams {
  messageType?: 'security' | 'system' | 'announcement' | 'otc' | 'payment'
  skip: number
  limit: number
}

export interface AgentListMyProjectsParams {
  skip: number
  limit: number
}

export interface AgentOtcGetHistoryParams {
  skip: number
  limit: number
  targetCurrency?: string
  baseCurrency?: string
}

export interface AgentGetAgentTradePerformanceChartParams {
  period: '1d' | '1w' | '1M' | '6M'
}

export interface AgentListPostsParams {
  projectID?: number
  authorID?: number
  status?: 'in_review' | 'published' | 'accepted' | 'rejected' | 'draft'
  skip: number
  limit: number
}

export interface AgentTogglePostStatusParams {
  postID: number
  published: boolean
}

export interface AgentDeletePostDocumentParams {
  postId: number
  documentId: number
}

export interface AgentDeletePostPhotoParams {
  postId: number
  photoId: number
}

export interface AgentGetProjectDetailsParams {
  token: string
}

export interface AgentCreateProjectLinkParams {
  token: string
}

export interface AgentToggleProjectLinkActiveParams {
  token: string
}

export interface AgentAddPostParams {
  token: string
}

export interface AgentEditPostParams {
  postId: number
  token: string
}

export interface AgentListProjectsParams {
  skip: number
  limit: number
  q?: string
  type?: string
  state?: string
  provinceID?: number
  countyID?: number
  cityID?: number
  districtID?: number
  orderBy?: string
  priceMin?: number
  priceMax?: number
}

export interface FileDownloadDocumentParams {
  path: string
}

export interface FileDownloadPhotoParams {
  path: string
}

export interface FileDownloadVideoParams {
  path: string
}

export interface UserListUserActivitiesParams {
  skip: number
  limit: number
  fromTimeUnix: number
  toTimeUnix: number
}

export interface UserGetAgentPostsParams {
  agentUUID: string
  skip: number
  limit: number
}

export interface UserGetAgentByUsernameParams {
  username: string
}

export interface UserGetAgentParams {
  uuid: string
}

export interface UserCheckBuyoutEligibilityParams {
  token: string
}

export interface UserListUserAssetTransfersParams {
  currency?: string
  skip: number
  limit: number
}

export interface UserDeleteBankAccountsParams {
  ids?: any[]
}

export interface UserCheckUserGetParams {
  phone?: string
  email?: string
}

export interface UserUserInboxListMessagesParams {
  messageType?: 'security' | 'system' | 'announcement' | 'otc' | 'payment'
  skip: number
  limit: number
}

export interface UserGetCountiesParams {
  provinceId: number
}

export interface UserGetCitiesParams {
  countyId: number
  provinceId: number
}

export interface UserGetDistrictsParams {
  cityID?: number
  countyId: number
  provinceId: number
}

export interface UserGetLoyaltyTransactionHistoryParams {
  userID: number
  skip: number
  limit: number
}

export interface UserOtcGetConvertRateParams {
  fromCurrency: string
  toCurrency: string
}

export interface UserGetOtcPriceParams {
  symbol: string
  base: string
  orderType: 'buy' | 'sell'
}

export interface UserOtcGetHistoryParams {
  skip: number
  limit: number
  targetCurrency?: string
  baseCurrency?: string
}

export interface UserGetAvailableCryptoContractsParams {
  direction: string
}

export interface UserGetPricePerformanceParams {
  symbols?: any[]
  base: string
  period: '1m' | '5m' | '1h' | '1d' | '7d' | '30d'
}

export interface UserGetProjectPostsParams {
  token: string
}

export interface UserGetProjectPriceChartParams {
  token: string
  period: '30d' | '90d' | '1y' | '5y'
}

export interface UserGetProjectPriceChartSnapshotParams {
  token: string
}

export interface UserGetRecentlyVisitedProjectsParams {
  limit: number
}

export interface UserGetProjectDetailsParams {
  token: string
}

export interface UserGetProjectCertDetailsParams {
  token: string
}

export interface UserListProjectsParams {
  skip: number
  limit: number
  q?: string
  kind?: 'property' | 'crypto'
  type?:
    | 'residential'
    | 'commercial'
    | 'office'
    | 'touristic'
    | 'industrial'
    | 'agricultural'
    | 'mining'
    | 'transportation'
    | 'other'
    | 'land'
  state?:
    | 'planning'
    | 'under_construction'
    | 'completed'
    | 'occupied'
    | 'for_sale'
    | 'for_rent'
    | 'other'
  tradeStatus?:
    | 'active'
    | 'suspended'
    | 'delisting'
    | 'coming_soon'
    | 'off_market'
  provinceID?: number
  countyID?: number
  cityID?: number
  districtID?: number
  orderBy?: 'expensive' | 'cheapest' | 'gainer' | 'loser' | 'newest'
  priceMin?: number
  priceMax?: number
  excludeIDs?: any[]
}

export interface UserListReferralsParams {
  userID?: number
  skip: number
  limit: number
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] =
        property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        )
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === 'object'
    ) {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== 'string'
    ) {
      body = JSON.stringify(body)
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    })
  }
}

/**
 * @title Malek (powered by RonyKIT)
 * @version v0.0.1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  healthz = {
    /**
     * No description
     *
     * @tags Health
     * @name HealthHealthz
     * @request GET:/healthz
     */
    healthHealthz: (params: RequestParams = {}) =>
      this.request<HealthHealthOutput, HealthError>({
        path: `/healthz`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  v1 = {
    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetAccount
     * @request GET:/v1/admin/account
     */
    adminGetAccount: (
      query: AdminGetAccountParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminAccount, AdminError>({
        path: `/v1/admin/account`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminCreateAccount
     * @request POST:/v1/admin/account
     */
    adminCreateAccount: (
      CreateAccountInput: AdminCreateAccountInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminCreateAccountOutput, AdminError>({
        path: `/v1/admin/account`,
        method: 'POST',
        body: CreateAccountInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminToggleAccountActive
     * @request PUT:/v1/admin/account/active
     */
    adminToggleAccountActive: (
      ToggleAccountActiveInput: AdminToggleAccountActiveInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminAccount, AdminError>({
        path: `/v1/admin/account/active`,
        method: 'PUT',
        body: ToggleAccountActiveInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminSetAccountAttributes
     * @request POST:/v1/admin/account/attributes
     */
    adminSetAccountAttributes: (
      SetAccountAttributesInput: AdminSetAccountAttributesInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminAccount, AdminError>({
        path: `/v1/admin/account/attributes`,
        method: 'POST',
        body: SetAccountAttributesInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetAccountByEmail
     * @request GET:/v1/admin/account/email
     */
    adminGetAccountByEmail: (
      query: AdminGetAccountByEmailParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminAccount, AdminError>({
        path: `/v1/admin/account/email`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminSetAccountEmail
     * @request POST:/v1/admin/account/email
     */
    adminSetAccountEmail: (
      SetEmailInput: AdminSetEmailInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminAccount, AdminError>({
        path: `/v1/admin/account/email`,
        method: 'POST',
        body: SetEmailInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetAccountByPhone
     * @request GET:/v1/admin/account/phone
     */
    adminGetAccountByPhone: (
      query: AdminGetAccountByPhoneParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminAccount, AdminError>({
        path: `/v1/admin/account/phone`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminSetAccountPhone
     * @request POST:/v1/admin/account/phone
     */
    adminSetAccountPhone: (
      SetPhoneInput: AdminSetPhoneInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminAccount, AdminError>({
        path: `/v1/admin/account/phone`,
        method: 'POST',
        body: SetPhoneInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminListAccounts
     * @request GET:/v1/admin/accounts
     */
    adminListAccounts: (
      query: AdminListAccountsParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminListAccountsOutput, AdminError>({
        path: `/v1/admin/accounts`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminBootstrap
     * @request POST:/v1/admin/bootstrap
     */
    adminBootstrap: (
      BootstrapInput: AdminBootstrapInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminBootstrapOutput, AdminError>({
        path: `/v1/admin/bootstrap`,
        method: 'POST',
        body: BootstrapInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminLoginByEmail
     * @request POST:/v1/admin/email/login
     */
    adminLoginByEmail: (
      LoginByEmailInput: AdminLoginByEmailInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminLoginByEmailOutput, AdminError>({
        path: `/v1/admin/email/login`,
        method: 'POST',
        body: LoginByEmailInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminCreateEmailOtp
     * @request POST:/v1/admin/email/otp
     */
    adminCreateEmailOtp: (
      CreateEmailOTPInput: AdminCreateEmailOTPInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminCreateOTPOutput, AdminError>({
        path: `/v1/admin/email/otp`,
        method: 'POST',
        body: CreateEmailOTPInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminListAgentKyCs
     * @request GET:/v1/admin/kyc/agent
     */
    adminListAgentKyCs: (
      query: AdminListAgentKyCsParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminListAgentKYCsOutput, AdminError>({
        path: `/v1/admin/kyc/agent`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminFinalizeAgentKyc
     * @request POST:/v1/admin/kyc/agent/finalize
     */
    adminFinalizeAgentKyc: (
      FinalizeAgentKYCInput: AdminFinalizeAgentKYCInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminFinalizeAgentKYCOutput, AdminError>({
        path: `/v1/admin/kyc/agent/finalize`,
        method: 'POST',
        body: FinalizeAgentKYCInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminListVideoKyCs
     * @request GET:/v1/admin/kyc/video
     */
    adminListVideoKyCs: (
      query: AdminListVideoKyCsParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminListVideoKYCsOutput, AdminError>({
        path: `/v1/admin/kyc/video`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminFinalizeVideoKyc
     * @request POST:/v1/admin/kyc/video/finalize
     */
    adminFinalizeVideoKyc: (
      FinalizeVideoKYCInput: AdminFinalizeVideoKYCInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminFinalizeVideoKYCOutput, AdminError>({
        path: `/v1/admin/kyc/video/finalize`,
        method: 'POST',
        body: FinalizeVideoKYCInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetLiquidityAccounts
     * @request GET:/v1/admin/ledger/liquidity
     */
    adminGetLiquidityAccounts: (
      query: AdminGetLiquidityAccountsParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminGetLiquidityAccountsOutput, AdminError>({
        path: `/v1/admin/ledger/liquidity`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminCloseTransferTicket
     * @request PATCH:/v1/admin/ledger/transfer-ticket
     */
    adminCloseTransferTicket: (
      CloseTicketInput: AdminCloseTicketInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminCloseTicketOutput, AdminError>({
        path: `/v1/admin/ledger/transfer-ticket`,
        method: 'PATCH',
        body: CloseTicketInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminListTransferTickets
     * @request GET:/v1/admin/ledger/transfer-tickets
     */
    adminListTransferTickets: (
      query: AdminListTransferTicketsParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminListTransferTicketsOutput, AdminError>({
        path: `/v1/admin/ledger/transfer-tickets`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminSaveLocation
     * @request POST:/v1/admin/location
     */
    adminSaveLocation: (
      SetLocationInput: AdminSetLocationInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminSetLocationOutput, AdminError>({
        path: `/v1/admin/location`,
        method: 'POST',
        body: SetLocationInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminDeleteLocation
     * @request DELETE:/v1/admin/location
     */
    adminDeleteLocation: (
      query: AdminDeleteLocationParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminDeleteLocationOutput, AdminError>({
        path: `/v1/admin/location`,
        method: 'DELETE',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetMissions
     * @request GET:/v1/admin/loyalty/mission
     */
    adminGetMissions: (
      query: AdminGetMissionsParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminGetMissionsOutput, AdminError>({
        path: `/v1/admin/loyalty/mission`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminSaveMission
     * @request POST:/v1/admin/loyalty/mission
     */
    adminSaveMission: (
      SaveMissionInput: AdminSaveMissionInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminSaveMissionOutput, AdminError>({
        path: `/v1/admin/loyalty/mission`,
        method: 'POST',
        body: SaveMissionInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminResendOtp
     * @request POST:/v1/admin/otp/resend
     */
    adminResendOtp: (
      ResendOTPInput: AdminResendOTPInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminResendOTPOutput, AdminError>({
        path: `/v1/admin/otp/resend`,
        method: 'POST',
        body: ResendOTPInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminListFiatTransactions
     * @request GET:/v1/admin/payment/fiat
     */
    adminListFiatTransactions: (
      query: AdminListFiatTransactionsParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminListFiatTransactionsOutput, AdminError>({
        path: `/v1/admin/payment/fiat`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminFiatDeposit
     * @request POST:/v1/admin/payment/fiat/deposit
     */
    adminFiatDeposit: (
      BackofficeFiatDepositInput: AdminBackofficeFiatDepositInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminBackofficeDepositOutput, AdminError>({
        path: `/v1/admin/payment/fiat/deposit`,
        method: 'POST',
        body: BackofficeFiatDepositInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminCompleteFiatWithdrawal
     * @request POST:/v1/admin/payment/fiat/withdrawal
     */
    adminCompleteFiatWithdrawal: (
      CompleteWithdrawalFiatInput: AdminCompleteWithdrawalFiatInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminCompleteWithdrawalFiatOutput, AdminError>({
        path: `/v1/admin/payment/fiat/withdrawal`,
        method: 'POST',
        body: CompleteWithdrawalFiatInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminLoginByPhone
     * @request POST:/v1/admin/phone/login
     */
    adminLoginByPhone: (
      LoginByPhoneInput: AdminLoginByPhoneInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminLoginByPhoneOutput, AdminError>({
        path: `/v1/admin/phone/login`,
        method: 'POST',
        body: LoginByPhoneInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminCreatePhoneOtp
     * @request POST:/v1/admin/phone/otp
     */
    adminCreatePhoneOtp: (
      CreateOTPInput: AdminCreateOTPInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminCreateOTPOutput, AdminError>({
        path: `/v1/admin/phone/otp`,
        method: 'POST',
        body: CreateOTPInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminSavePrice
     * @request POST:/v1/admin/price
     */
    adminSavePrice: (
      SavePriceInput: AdminSavePriceInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminSavePriceOutput, AdminError>({
        path: `/v1/admin/price`,
        method: 'POST',
        body: SavePriceInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminCreateProject
     * @request POST:/v1/admin/project
     */
    adminCreateProject: (
      CreateProjectInput: AdminCreateProjectInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminCreateProjectOutput, AdminError>({
        path: `/v1/admin/project`,
        method: 'POST',
        body: CreateProjectInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminUpdateProjectAgentLinkStatus
     * @request PUT:/v1/admin/project/agent/link/status
     */
    adminUpdateProjectAgentLinkStatus: (
      UpdateProjectAgentLinkStatusInput: AdminUpdateProjectAgentLinkStatusInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminUpdateProjectAgentLinkStatusOutput, AdminError>({
        path: `/v1/admin/project/agent/link/status`,
        method: 'PUT',
        body: UpdateProjectAgentLinkStatusInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminListProjectAgentLinks
     * @request GET:/v1/admin/project/agent/links/list
     */
    adminListProjectAgentLinks: (
      query: AdminListProjectAgentLinksParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminListProjectAgentLinksOutput, AdminError>({
        path: `/v1/admin/project/agent/links/list`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetProjectAgentLinks
     * @request GET:/v1/admin/project/agent/{userID}/links
     */
    adminGetProjectAgentLinks: (
      { userId, ...query }: AdminGetProjectAgentLinksParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminGetProjectAgentLinksOutput, AdminError>({
        path: `/v1/admin/project/agent/${userId}/links`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminUploadProjectDocument
     * @request POST:/v1/admin/project/document
     * @deprecated
     */
    adminUploadProjectDocument: (params: RequestParams = {}) =>
      this.request<AdminUploadProjectDocumentOutput, AdminError>({
        path: `/v1/admin/project/document`,
        method: 'POST',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminPrepareProjectDocumentUpload
     * @request POST:/v1/admin/project/document/prepare
     */
    adminPrepareProjectDocumentUpload: (
      PrepareProjectDocumentUploadInput: AdminPrepareProjectDocumentUploadInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminPrepareProjectDocumentUploadOutput, AdminError>({
        path: `/v1/admin/project/document/prepare`,
        method: 'POST',
        body: PrepareProjectDocumentUploadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminVerifyProjectDocumentUpload
     * @request POST:/v1/admin/project/document/verify
     */
    adminVerifyProjectDocumentUpload: (
      VerifyProjectDocumentUploadInput: AdminVerifyProjectDocumentUploadInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminVerifyProjectDocumentUploadOutput, AdminError>({
        path: `/v1/admin/project/document/verify`,
        method: 'POST',
        body: VerifyProjectDocumentUploadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminUploadProjectLogo
     * @request POST:/v1/admin/project/logo
     * @deprecated
     */
    adminUploadProjectLogo: (params: RequestParams = {}) =>
      this.request<AdminUploadProjectLogoOutput, AdminError>({
        path: `/v1/admin/project/logo`,
        method: 'POST',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminDeleteProjectLogo
     * @request DELETE:/v1/admin/project/logo
     */
    adminDeleteProjectLogo: (
      query: AdminDeleteProjectLogoParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminDeleteProjectLogoOutput, AdminError>({
        path: `/v1/admin/project/logo`,
        method: 'DELETE',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminPrepareProjectLogoUpload
     * @request POST:/v1/admin/project/logo/prepare
     */
    adminPrepareProjectLogoUpload: (
      PrepareProjectLogoUploadInput: AdminPrepareProjectLogoUploadInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminPrepareProjectLogoUploadOutput, AdminError>({
        path: `/v1/admin/project/logo/prepare`,
        method: 'POST',
        body: PrepareProjectLogoUploadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminVerifyProjectLogoUpload
     * @request POST:/v1/admin/project/logo/verify
     */
    adminVerifyProjectLogoUpload: (
      VerifyProjectLogoUploadInput: AdminVerifyProjectLogoUploadInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminVerifyProjectLogoUploadOutput, AdminError>({
        path: `/v1/admin/project/logo/verify`,
        method: 'POST',
        body: VerifyProjectLogoUploadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminUploadProjectPhoto
     * @request POST:/v1/admin/project/photo
     * @deprecated
     */
    adminUploadProjectPhoto: (params: RequestParams = {}) =>
      this.request<AdminUploadProjectPhotoOutput, AdminError>({
        path: `/v1/admin/project/photo`,
        method: 'POST',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminSetProjectDefaultPhoto
     * @request POST:/v1/admin/project/photo/default
     */
    adminSetProjectDefaultPhoto: (
      SetProjectDefaultPhotoInput: AdminSetProjectDefaultPhotoInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminSetProjectDefaultPhotoOutput, AdminError>({
        path: `/v1/admin/project/photo/default`,
        method: 'POST',
        body: SetProjectDefaultPhotoInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminPrepareProjectPhotoUpload
     * @request POST:/v1/admin/project/photo/prepare
     */
    adminPrepareProjectPhotoUpload: (
      PrepareProjectPhotoUploadInput: AdminPrepareProjectPhotoUploadInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminPrepareProjectPhotoUploadOutput, AdminError>({
        path: `/v1/admin/project/photo/prepare`,
        method: 'POST',
        body: PrepareProjectPhotoUploadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminVerifyProjectPhotoUpload
     * @request POST:/v1/admin/project/photo/verify
     */
    adminVerifyProjectPhotoUpload: (
      VerifyProjectPhotoUploadInput: AdminVerifyProjectPhotoUploadInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminVerifyProjectPhotoUploadOutput, AdminError>({
        path: `/v1/admin/project/photo/verify`,
        method: 'POST',
        body: VerifyProjectPhotoUploadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminDeleteProjectPost
     * @request DELETE:/v1/admin/project/post
     */
    adminDeleteProjectPost: (
      query: AdminDeleteProjectPostParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminDeletePostOutput, AdminError>({
        path: `/v1/admin/project/post`,
        method: 'DELETE',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminAuditProjectPost
     * @request POST:/v1/admin/project/post/audit
     */
    adminAuditProjectPost: (
      AuditPostInput: AdminAuditPostInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminAuditPostOutput, AdminError>({
        path: `/v1/admin/project/post/audit`,
        method: 'POST',
        body: AuditPostInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminListProjectPosts
     * @request GET:/v1/admin/project/post/list
     */
    adminListProjectPosts: (
      query: AdminListProjectPostsParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminListPostsOutput, AdminError>({
        path: `/v1/admin/project/post/list`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetProjectPriceExpr
     * @request GET:/v1/admin/project/price/expr
     */
    adminGetProjectPriceExpr: (
      query: AdminGetProjectPriceExprParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminGetProjectPriceExprOutput, AdminError>({
        path: `/v1/admin/project/price/expr`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminSetProjectPriceExpr
     * @request PATCH:/v1/admin/project/price/expr
     */
    adminSetProjectPriceExpr: (
      SetProjectPriceExprInput: AdminSetProjectPriceExprInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminSetProjectPriceExprOutput, AdminError>({
        path: `/v1/admin/project/price/expr`,
        method: 'PATCH',
        body: SetProjectPriceExprInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminSetProjectPriority
     * @request POST:/v1/admin/project/priority
     */
    adminSetProjectPriority: (
      SetProjectPriorityInput: AdminSetProjectPriorityInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminSetProjectPriorityOutput, AdminError>({
        path: `/v1/admin/project/priority`,
        method: 'POST',
        body: SetProjectPriorityInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminDeleteProjectDocument
     * @request DELETE:/v1/admin/project/{projectID}/document/{documentID}
     */
    adminDeleteProjectDocument: (
      { projectId, documentId, ...query }: AdminDeleteProjectDocumentParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminDeleteDocumentOutput, AdminError>({
        path: `/v1/admin/project/${projectId}/document/${documentId}`,
        method: 'DELETE',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminDeleteProjectPhoto
     * @request DELETE:/v1/admin/project/{projectID}/photo/{photoID}
     */
    adminDeleteProjectPhoto: (
      { projectId, photoId, ...query }: AdminDeleteProjectPhotoParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminDeletePhotoOutput, AdminError>({
        path: `/v1/admin/project/${projectId}/photo/${photoId}`,
        method: 'DELETE',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetProject
     * @request GET:/v1/admin/project/{token}
     */
    adminGetProject: (
      { token, ...query }: AdminGetProjectParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminGetProjectOutput, AdminError>({
        path: `/v1/admin/project/${token}`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminSetProjectMarketDetails
     * @request PATCH:/v1/admin/project/{token}/market
     */
    adminSetProjectMarketDetails: (
      { token, ...query }: AdminSetProjectMarketDetailsParams,
      SetProjectMarketDetailsInput: AdminSetProjectMarketDetailsInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminSetProjectMarketDetailsOutput, AdminError>({
        path: `/v1/admin/project/${token}/market`,
        method: 'PATCH',
        body: SetProjectMarketDetailsInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminListProjects
     * @request GET:/v1/admin/projects
     */
    adminListProjects: (
      query: AdminListProjectsParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminListProjectsOutput, AdminError>({
        path: `/v1/admin/projects`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminAuthRefresh
     * @request POST:/v1/admin/refresh
     */
    adminAuthRefresh: (
      RefreshTokenInput: AdminRefreshTokenInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminRefreshTokenOutput, AdminError>({
        path: `/v1/admin/refresh`,
        method: 'POST',
        body: RefreshTokenInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetUser
     * @request GET:/v1/admin/user
     */
    adminGetUser: (query: AdminGetUserParams, params: RequestParams = {}) =>
      this.request<AdminUser, AdminError>({
        path: `/v1/admin/user`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminDeleteUser
     * @request DELETE:/v1/admin/user
     */
    adminDeleteUser: (
      query: AdminDeleteUserParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminDeleteUserOutput, AdminError>({
        path: `/v1/admin/user`,
        method: 'DELETE',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminListUserBankAccounts
     * @request GET:/v1/admin/user/bank/accounts
     */
    adminListUserBankAccounts: (
      query: AdminListUserBankAccountsParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminListUserBankAccountsOutput, AdminError>({
        path: `/v1/admin/user/bank/accounts`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetUserByEmail
     * @request GET:/v1/admin/user/email
     */
    adminGetUserByEmail: (
      query: AdminGetUserByEmailParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminUser, AdminError>({
        path: `/v1/admin/user/email`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminListUsers
     * @request GET:/v1/admin/user/list
     */
    adminListUsers: (query: AdminListUsersParams, params: RequestParams = {}) =>
      this.request<AdminListUsersOutput, AdminError>({
        path: `/v1/admin/user/list`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetUserOtcHistory
     * @request GET:/v1/admin/user/otc/history
     */
    adminGetUserOtcHistory: (
      query: AdminGetUserOtcHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminGetOTCHistoryOutput, AdminError>({
        path: `/v1/admin/user/otc/history`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminUpdateUserPersonalInfo
     * @request PATCH:/v1/admin/user/personal-info
     */
    adminUpdateUserPersonalInfo: (
      UpdateUserPersonalInfoInput: AdminUpdateUserPersonalInfoInput,
      params: RequestParams = {},
    ) =>
      this.request<AdminUser, AdminError>({
        path: `/v1/admin/user/personal-info`,
        method: 'PATCH',
        body: UpdateUserPersonalInfoInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetUserByPhone
     * @request GET:/v1/admin/user/phone
     */
    adminGetUserByPhone: (
      query: AdminGetUserByPhoneParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminUser, AdminError>({
        path: `/v1/admin/user/phone`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetUserPortfolio
     * @request GET:/v1/admin/user/portfolio
     */
    adminGetUserPortfolio: (
      query: AdminGetUserPortfolioParams,
      params: RequestParams = {},
    ) =>
      this.request<AdminGetUserPortfolioOutput, AdminError>({
        path: `/v1/admin/user/portfolio`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentListAvailableProjects
     * @request GET:/v1/agent/available-projects
     */
    agentListAvailableProjects: (
      query: AgentListAvailableProjectsParams,
      params: RequestParams = {},
    ) =>
      this.request<AgentListAvailableProjectsOutput, AgentError>({
        path: `/v1/agent/available-projects`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentListBankAccounts
     * @request GET:/v1/agent/banks
     */
    agentListBankAccounts: (params: RequestParams = {}) =>
      this.request<AgentGetBankAccountsOutput, AgentError>({
        path: `/v1/agent/banks`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentAddBankAccount
     * @request POST:/v1/agent/banks
     */
    agentAddBankAccount: (
      AddUserBankAccountInput: AgentAddUserBankAccountInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentAddUserBankAccountOutput, AgentError>({
        path: `/v1/agent/banks`,
        method: 'POST',
        body: AddUserBankAccountInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentDeleteBankAccounts
     * @request DELETE:/v1/agent/banks
     */
    agentDeleteBankAccounts: (
      query: AgentDeleteBankAccountsParams,
      params: RequestParams = {},
    ) =>
      this.request<AgentDeleteBankAccountsOutput, AgentError>({
        path: `/v1/agent/banks`,
        method: 'DELETE',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentSetDefaultBankAccount
     * @request PUT:/v1/agent/banks/default
     */
    agentSetDefaultBankAccount: (
      SetDefaultBankAccountInput: AgentSetDefaultBankAccountInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentSetDefaultBankAccountOutput, AgentError>({
        path: `/v1/agent/banks/default`,
        method: 'PUT',
        body: SetDefaultBankAccountInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentCheck
     * @request GET:/v1/agent/check
     */
    agentCheck: (query: AgentCheckParams, params: RequestParams = {}) =>
      this.request<AgentCheckUserOutput, AgentError>({
        path: `/v1/agent/check`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentSetUserEmail
     * @request PATCH:/v1/agent/email
     */
    agentSetUserEmail: (
      SetUserEmailInput: AgentSetUserEmailInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentUser, AgentError>({
        path: `/v1/agent/email`,
        method: 'PATCH',
        body: SetUserEmailInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentLoginByEmail
     * @request POST:/v1/agent/email/login
     */
    agentLoginByEmail: (
      LoginByEmailInput: AgentLoginByEmailInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentLoginByEmailOutput, AgentError>({
        path: `/v1/agent/email/login`,
        method: 'POST',
        body: LoginByEmailInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentCreateEmailOtp
     * @request POST:/v1/agent/email/otp
     */
    agentCreateEmailOtp: (
      CreateEmailOTPInput: AgentCreateEmailOTPInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentCreateOTPOutput, AgentError>({
        path: `/v1/agent/email/otp`,
        method: 'POST',
        body: CreateEmailOTPInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentRegisterByEmail
     * @request POST:/v1/agent/email/register
     */
    agentRegisterByEmail: (
      RegisterByEmailInput: AgentRegisterByEmailInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentRegisterByEmailOutput, AgentError>({
        path: `/v1/agent/email/register`,
        method: 'POST',
        body: RegisterByEmailInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentInboxListMessages
     * @request GET:/v1/agent/inbox/message
     */
    agentInboxListMessages: (
      query: AgentInboxListMessagesParams,
      params: RequestParams = {},
    ) =>
      this.request<AgentInboxListMessagesOutput, AgentError>({
        path: `/v1/agent/inbox/message`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentInboxMarkAsRead
     * @request POST:/v1/agent/inbox/read
     */
    agentInboxMarkAsRead: (
      InboxMarkReadInput: AgentInboxMarkReadInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentInboxMarkAsReadOutput, AgentError>({
        path: `/v1/agent/inbox/read`,
        method: 'POST',
        body: InboxMarkReadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentInboxMarkAllAsRead
     * @request POST:/v1/agent/inbox/read/all
     */
    agentInboxMarkAllAsRead: (
      InboxMarkAllReadInput: AgentInboxMarkAllReadInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentInboxMarkAllAsReadOutput, AgentError>({
        path: `/v1/agent/inbox/read/all`,
        method: 'POST',
        body: InboxMarkAllReadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentStartKyc
     * @request POST:/v1/agent/kyc
     */
    agentStartKyc: (
      AgentKYCStartInput: AgentAgentKYCStartInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentStartAgentKYCOutput, AgentError>({
        path: `/v1/agent/kyc`,
        method: 'POST',
        body: AgentKYCStartInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentAddKycDocument
     * @request POST:/v1/agent/kyc/document/add
     */
    agentAddKycDocument: (
      AddAgentDocumentInput: AgentAddAgentDocumentInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentKYCDocument, AgentError>({
        path: `/v1/agent/kyc/document/add`,
        method: 'POST',
        body: AddAgentDocumentInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentListMyProjects
     * @request GET:/v1/agent/my-projects
     */
    agentListMyProjects: (
      query: AgentListMyProjectsParams,
      params: RequestParams = {},
    ) =>
      this.request<AgentListMyProjectsOutput, AgentError>({
        path: `/v1/agent/my-projects`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentOtcGetHistory
     * @request GET:/v1/agent/otc/txn/history
     */
    agentOtcGetHistory: (
      query: AgentOtcGetHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<AgentGetOTCHistoryOutput, AgentError>({
        path: `/v1/agent/otc/txn/history`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentResendOtp
     * @request POST:/v1/agent/otp/resend
     */
    agentResendOtp: (
      ResendOTPInput: AgentResendOTPInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentResendOTPOutput, AgentError>({
        path: `/v1/agent/otp/resend`,
        method: 'POST',
        body: ResendOTPInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentLoginByPassword
     * @request POST:/v1/agent/password/login
     */
    agentLoginByPassword: (
      LoginByPasswordInput: AgentLoginByPasswordInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentLoginByPasswordOutput, AgentError>({
        path: `/v1/agent/password/login`,
        method: 'POST',
        body: LoginByPasswordInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentGetPasswordSettings
     * @request GET:/v1/agent/password/settings
     */
    agentGetPasswordSettings: (params: RequestParams = {}) =>
      this.request<AgentGetPasswordSettingsOutput, AgentError>({
        path: `/v1/agent/password/settings`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentSetPasswordSettings
     * @request PATCH:/v1/agent/password/settings
     */
    agentSetPasswordSettings: (
      SetPasswordSettingsInput: AgentSetPasswordSettingsInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentSetPasswordSettingsOutput, AgentError>({
        path: `/v1/agent/password/settings`,
        method: 'PATCH',
        body: SetPasswordSettingsInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentGetFiatTransactionHistory
     * @request POST:/v1/agent/payment/fiat/history
     */
    agentGetFiatTransactionHistory: (
      GetFiatTransactionHistoryInput: AgentGetFiatTransactionHistoryInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentGetFiatTransactionHistoryOutput, AgentError>({
        path: `/v1/agent/payment/fiat/history`,
        method: 'POST',
        body: GetFiatTransactionHistoryInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentCancelWithdrawalFiat
     * @request PATCH:/v1/agent/payment/withdrawal/fiat/cancel
     */
    agentCancelWithdrawalFiat: (
      CancelWithdrawalFiatInput: AgentCancelWithdrawalFiatInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentCancelWithdrawalFiatOutput, AgentError>({
        path: `/v1/agent/payment/withdrawal/fiat/cancel`,
        method: 'PATCH',
        body: CancelWithdrawalFiatInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentCalculateWithdrawalCost
     * @request POST:/v1/agent/payment/withdrawal/fiat/cost
     */
    agentCalculateWithdrawalCost: (
      CalculateWithdrawalCostInput: AgentCalculateWithdrawalCostInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentCalculateWithdrawalCostOutput, AgentError>({
        path: `/v1/agent/payment/withdrawal/fiat/cost`,
        method: 'POST',
        body: CalculateWithdrawalCostInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentInitiateWithdrawalFiat
     * @request POST:/v1/agent/payment/withdrawal/fiat/initiate
     */
    agentInitiateWithdrawalFiat: (
      WithdrawFiatInput: AgentWithdrawFiatInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentWithdrawFiatOutput, AgentError>({
        path: `/v1/agent/payment/withdrawal/fiat/initiate`,
        method: 'POST',
        body: WithdrawFiatInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentGetTradePerformance
     * @request GET:/v1/agent/performance/trade
     */
    agentGetTradePerformance: (params: RequestParams = {}) =>
      this.request<AgentGetAgentPerformanceOutput, AgentError>({
        path: `/v1/agent/performance/trade`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentGetAgentTradePerformanceChart
     * @request GET:/v1/agent/performance/trade/chart
     */
    agentGetAgentTradePerformanceChart: (
      query: AgentGetAgentTradePerformanceChartParams,
      params: RequestParams = {},
    ) =>
      this.request<AgentGetAgentTradePerformanceChartOutput, AgentError>({
        path: `/v1/agent/performance/trade/chart`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentSetUserPhone
     * @request PATCH:/v1/agent/phone
     */
    agentSetUserPhone: (
      SetUserPhoneInput: AgentSetUserPhoneInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentUser, AgentError>({
        path: `/v1/agent/phone`,
        method: 'PATCH',
        body: SetUserPhoneInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentLoginByPhone
     * @request POST:/v1/agent/phone/login
     */
    agentLoginByPhone: (
      LoginByPhoneInput: AgentLoginByPhoneInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentLoginByPhoneOutput, AgentError>({
        path: `/v1/agent/phone/login`,
        method: 'POST',
        body: LoginByPhoneInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentCreatePhoneOtp
     * @request POST:/v1/agent/phone/otp
     */
    agentCreatePhoneOtp: (
      CreateOTPInput: AgentCreateOTPInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentCreateOTPOutput, AgentError>({
        path: `/v1/agent/phone/otp`,
        method: 'POST',
        body: CreateOTPInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentRegisterByPhone
     * @request POST:/v1/agent/phone/register
     */
    agentRegisterByPhone: (
      RegisterByPhoneInput: AgentRegisterByPhoneInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentRegisterByPhoneOutput, AgentError>({
        path: `/v1/agent/phone/register`,
        method: 'POST',
        body: RegisterByPhoneInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentGetPortfolio
     * @request GET:/v1/agent/portfolio
     */
    agentGetPortfolio: (params: RequestParams = {}) =>
      this.request<AgentGetUserPortfolioOutput, AgentError>({
        path: `/v1/agent/portfolio`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentGetPortfolioChart
     * @request POST:/v1/agent/portfolio/chart
     */
    agentGetPortfolioChart: (
      GetPortfolioChartInput: AgentGetPortfolioChartInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentGetPortfolioChartOutput, AgentError>({
        path: `/v1/agent/portfolio/chart`,
        method: 'POST',
        body: GetPortfolioChartInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentGetWalletPortfolioChart
     * @request POST:/v1/agent/portfolio/chart/wallet
     */
    agentGetWalletPortfolioChart: (
      GetWalletPortfolioChartInput: AgentGetWalletPortfolioChartInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentGetWalletPortfolioChartOutput, AgentError>({
        path: `/v1/agent/portfolio/chart/wallet`,
        method: 'POST',
        body: GetWalletPortfolioChartInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentSetProfile
     * @request POST:/v1/agent/profile
     */
    agentSetProfile: (
      SetProfileInput: AgentSetProfileInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentSetProfileOutput, AgentError>({
        path: `/v1/agent/profile`,
        method: 'POST',
        body: SetProfileInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentUploadCoverPicture
     * @request POST:/v1/agent/profile/cover
     */
    agentUploadCoverPicture: (params: RequestParams = {}) =>
      this.request<AgentUser, AgentError>({
        path: `/v1/agent/profile/cover`,
        method: 'POST',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentUploadProfilePicture
     * @request POST:/v1/agent/profile/photo
     */
    agentUploadProfilePicture: (params: RequestParams = {}) =>
      this.request<AgentUser, AgentError>({
        path: `/v1/agent/profile/photo`,
        method: 'POST',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentUploadPostDocument
     * @request POST:/v1/agent/project/post/document
     * @deprecated
     */
    agentUploadPostDocument: (params: RequestParams = {}) =>
      this.request<AgentUploadPostDocumentOutput, AgentError>({
        path: `/v1/agent/project/post/document`,
        method: 'POST',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentPreparePostDocumentUpload
     * @request POST:/v1/agent/project/post/document/prepare
     */
    agentPreparePostDocumentUpload: (
      PreparePostDocumentUploadInput: AgentPreparePostDocumentUploadInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentPreparePostDocumentUploadOutput, AgentError>({
        path: `/v1/agent/project/post/document/prepare`,
        method: 'POST',
        body: PreparePostDocumentUploadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentVerifyPostDocumentUpload
     * @request POST:/v1/agent/project/post/document/verify
     */
    agentVerifyPostDocumentUpload: (
      VerifyPostDocumentUploadInput: AgentVerifyPostDocumentUploadInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentVerifyPostDocumentUploadOutput, AgentError>({
        path: `/v1/agent/project/post/document/verify`,
        method: 'POST',
        body: VerifyPostDocumentUploadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentListPosts
     * @request GET:/v1/agent/project/post/list
     */
    agentListPosts: (query: AgentListPostsParams, params: RequestParams = {}) =>
      this.request<AgentListPostsOutput, AgentError>({
        path: `/v1/agent/project/post/list`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentUploadPostPhoto
     * @request POST:/v1/agent/project/post/photo
     * @deprecated
     */
    agentUploadPostPhoto: (params: RequestParams = {}) =>
      this.request<AgentUploadPostPhotoOutput, AgentError>({
        path: `/v1/agent/project/post/photo`,
        method: 'POST',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentPreparePostPhotoUpload
     * @request POST:/v1/agent/project/post/photo/prepare
     */
    agentPreparePostPhotoUpload: (
      PreparePostPhotoUploadInput: AgentPreparePostPhotoUploadInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentPreparePostPhotoUploadOutput, AgentError>({
        path: `/v1/agent/project/post/photo/prepare`,
        method: 'POST',
        body: PreparePostPhotoUploadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentVerifyPostPhotoUpload
     * @request POST:/v1/agent/project/post/photo/verify
     */
    agentVerifyPostPhotoUpload: (
      VerifyPostPhotoUploadInput: AgentVerifyPostPhotoUploadInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentVerifyPostPhotoUploadOutput, AgentError>({
        path: `/v1/agent/project/post/photo/verify`,
        method: 'POST',
        body: VerifyPostPhotoUploadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentTogglePostStatus
     * @request GET:/v1/agent/project/post/status/toggle
     */
    agentTogglePostStatus: (
      query: AgentTogglePostStatusParams,
      params: RequestParams = {},
    ) =>
      this.request<AgentTogglePostStatusOutput, AgentError>({
        path: `/v1/agent/project/post/status/toggle`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentDeletePostDocument
     * @request DELETE:/v1/agent/project/post/{postID}/document/{documentID}
     */
    agentDeletePostDocument: (
      { postId, documentId, ...query }: AgentDeletePostDocumentParams,
      params: RequestParams = {},
    ) =>
      this.request<AgentDeletePostDocumentOutput, AgentError>({
        path: `/v1/agent/project/post/${postId}/document/${documentId}`,
        method: 'DELETE',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentDeletePostPhoto
     * @request DELETE:/v1/agent/project/post/{postID}/photo/{photoID}
     */
    agentDeletePostPhoto: (
      { postId, photoId, ...query }: AgentDeletePostPhotoParams,
      params: RequestParams = {},
    ) =>
      this.request<AgentDeletePostPhotoOutput, AgentError>({
        path: `/v1/agent/project/post/${postId}/photo/${photoId}`,
        method: 'DELETE',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentGetProjectDetails
     * @request GET:/v1/agent/project/{token}
     */
    agentGetProjectDetails: (
      { token, ...query }: AgentGetProjectDetailsParams,
      params: RequestParams = {},
    ) =>
      this.request<AgentGetProjectOutput, AgentError>({
        path: `/v1/agent/project/${token}`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentCreateProjectLink
     * @request POST:/v1/agent/project/{token}/link
     */
    agentCreateProjectLink: (
      { token, ...query }: AgentCreateProjectLinkParams,
      CreateProjectLinkInput: AgentCreateProjectLinkInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentCreateProjectAgentLinkOutput, AgentError>({
        path: `/v1/agent/project/${token}/link`,
        method: 'POST',
        body: CreateProjectLinkInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentToggleProjectLinkActive
     * @request PATCH:/v1/agent/project/{token}/link/active
     */
    agentToggleProjectLinkActive: (
      { token, ...query }: AgentToggleProjectLinkActiveParams,
      ToggleProjectLinkActiveInput: AgentToggleProjectLinkActiveInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentToggleProjectAgentLinkActiveOutput, AgentError>({
        path: `/v1/agent/project/${token}/link/active`,
        method: 'PATCH',
        body: ToggleProjectLinkActiveInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentAddPost
     * @request POST:/v1/agent/project/{token}/post
     */
    agentAddPost: (
      { token, ...query }: AgentAddPostParams,
      AddPostInput: AgentAddPostInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentAddPostOutput, AgentError>({
        path: `/v1/agent/project/${token}/post`,
        method: 'POST',
        body: AddPostInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentEditPost
     * @request PATCH:/v1/agent/project/{token}/post/{postID}
     */
    agentEditPost: (
      { postId, token, ...query }: AgentEditPostParams,
      EditPostInput: AgentEditPostInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentEditPostOutput, AgentError>({
        path: `/v1/agent/project/${token}/post/${postId}`,
        method: 'PATCH',
        body: EditPostInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentListProjects
     * @request GET:/v1/agent/projects
     */
    agentListProjects: (
      query: AgentListProjectsParams,
      params: RequestParams = {},
    ) =>
      this.request<AgentListProjectsOutput, AgentError>({
        path: `/v1/agent/projects`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentGetReferralCodes
     * @request GET:/v1/agent/referral/code
     */
    agentGetReferralCodes: (params: RequestParams = {}) =>
      this.request<AgentGetReferralCodesOutput, AgentError>({
        path: `/v1/agent/referral/code`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentAuthRefresh
     * @request POST:/v1/agent/refresh
     */
    agentAuthRefresh: (
      RefreshTokenInput: AgentRefreshTokenInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentRefreshTokenOutput, AgentError>({
        path: `/v1/agent/refresh`,
        method: 'POST',
        body: RefreshTokenInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentSetUsername
     * @request POST:/v1/agent/username
     */
    agentSetUsername: (
      SetUsernameInput: AgentSetUsernameInput,
      params: RequestParams = {},
    ) =>
      this.request<AgentUser, AgentError>({
        path: `/v1/agent/username`,
        method: 'POST',
        body: SetUsernameInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name AgentAuthVerify
     * @request GET:/v1/agent/verify
     */
    agentAuthVerify: (params: RequestParams = {}) =>
      this.request<AgentUser, AgentError>({
        path: `/v1/agent/verify`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileDownloadDocument
     * @request GET:/v1/file/document
     */
    fileDownloadDocument: (
      query: FileDownloadDocumentParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/file/document`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileDownloadPhoto
     * @request GET:/v1/file/photo
     */
    fileDownloadPhoto: (
      query: FileDownloadPhotoParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/file/photo`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileDownloadVideo
     * @request GET:/v1/file/video
     */
    fileDownloadVideo: (
      query: FileDownloadVideoParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/file/video`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserListUserActivities
     * @request GET:/v1/user/activities
     */
    userListUserActivities: (
      query: UserListUserActivitiesParams,
      params: RequestParams = {},
    ) =>
      this.request<UserListUserActivitiesOutput, UserError>({
        path: `/v1/user/activities`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetAgentPosts
     * @request GET:/v1/user/agent/posts
     */
    userGetAgentPosts: (
      query: UserGetAgentPostsParams,
      params: RequestParams = {},
    ) =>
      this.request<UserListPostsOutput, UserError>({
        path: `/v1/user/agent/posts`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetAgentByUsername
     * @request GET:/v1/user/agent/username/{username}
     */
    userGetAgentByUsername: (
      { username, ...query }: UserGetAgentByUsernameParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetAgentOutput, UserError>({
        path: `/v1/user/agent/username/${username}`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetAgent
     * @request GET:/v1/user/agent/{uuid}
     */
    userGetAgent: (
      { uuid, ...query }: UserGetAgentParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetAgentOutput, UserError>({
        path: `/v1/user/agent/${uuid}`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserCheckBuyoutEligibility
     * @request GET:/v1/user/asset/buyout/eligibility
     */
    userCheckBuyoutEligibility: (
      query: UserCheckBuyoutEligibilityParams,
      params: RequestParams = {},
    ) =>
      this.request<UserCheckBuyoutEligibilityOutput, UserError>({
        path: `/v1/user/asset/buyout/eligibility`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserListUserAssetTransfers
     * @request GET:/v1/user/asset/transfer
     */
    userListUserAssetTransfers: (
      query: UserListUserAssetTransfersParams,
      params: RequestParams = {},
    ) =>
      this.request<UserListUserAssetTransfersOutput, UserError>({
        path: `/v1/user/asset/transfer`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserTransferUserAsset
     * @request POST:/v1/user/asset/transfer
     */
    userTransferUserAsset: (
      UserAssetTransferInput: UserUserAssetTransferInput,
      params: RequestParams = {},
    ) =>
      this.request<UserUserAssetTransferOutput, UserError>({
        path: `/v1/user/asset/transfer`,
        method: 'POST',
        body: UserAssetTransferInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserListUserBankAccounts
     * @request GET:/v1/user/banks
     */
    userListUserBankAccounts: (params: RequestParams = {}) =>
      this.request<UserGetUserBankAccountsOutput, UserError>({
        path: `/v1/user/banks`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserAddUserBankAccount
     * @request POST:/v1/user/banks
     */
    userAddUserBankAccount: (
      AddUserBankAccountInput: UserAddUserBankAccountInput,
      params: RequestParams = {},
    ) =>
      this.request<UserAddUserBankAccountOutput, UserError>({
        path: `/v1/user/banks`,
        method: 'POST',
        body: AddUserBankAccountInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserDeleteBankAccounts
     * @request DELETE:/v1/user/banks
     */
    userDeleteBankAccounts: (
      query: UserDeleteBankAccountsParams,
      params: RequestParams = {},
    ) =>
      this.request<UserDeleteUserBankAccountsOutput, UserError>({
        path: `/v1/user/banks`,
        method: 'DELETE',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserSetDefaultUserBankAccount
     * @request PUT:/v1/user/banks/default
     */
    userSetDefaultUserBankAccount: (
      SetDefaultUserBankAccountInput: UserSetDefaultUserBankAccountInput,
      params: RequestParams = {},
    ) =>
      this.request<UserSetDefaultUserBankAccountOutput, UserError>({
        path: `/v1/user/banks/default`,
        method: 'PUT',
        body: SetDefaultUserBankAccountInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserCheckUserGet
     * @request GET:/v1/user/check
     */
    userCheckUserGet: (
      query: UserCheckUserGetParams,
      params: RequestParams = {},
    ) =>
      this.request<UserCheckUserOutput, UserError>({
        path: `/v1/user/check`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserCheckUserPost
     * @request POST:/v1/user/check
     */
    userCheckUserPost: (
      CheckUserInput: UserCheckUserInput,
      params: RequestParams = {},
    ) =>
      this.request<UserCheckUserOutput, UserError>({
        path: `/v1/user/check`,
        method: 'POST',
        body: CheckUserInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserSetUserDetails
     * @request POST:/v1/user/details
     */
    userSetUserDetails: (
      SetUserDetailInput: UserSetUserDetailInput,
      params: RequestParams = {},
    ) =>
      this.request<UserUser, UserError>({
        path: `/v1/user/details`,
        method: 'POST',
        body: SetUserDetailInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserSetUserEmail
     * @request PATCH:/v1/user/email
     */
    userSetUserEmail: (
      SetUserEmailInput: UserSetUserEmailInput,
      params: RequestParams = {},
    ) =>
      this.request<UserUser, UserError>({
        path: `/v1/user/email`,
        method: 'PATCH',
        body: SetUserEmailInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserLoginByEmail
     * @request POST:/v1/user/email/login
     */
    userLoginByEmail: (
      LoginByEmailInput: UserLoginByEmailInput,
      params: RequestParams = {},
    ) =>
      this.request<UserLoginByEmailOutput, UserError>({
        path: `/v1/user/email/login`,
        method: 'POST',
        body: LoginByEmailInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserCreateEmailOtp
     * @request POST:/v1/user/email/otp
     */
    userCreateEmailOtp: (
      CreateEmailOTPInput: UserCreateEmailOTPInput,
      params: RequestParams = {},
    ) =>
      this.request<UserCreateOTPOutput, UserError>({
        path: `/v1/user/email/otp`,
        method: 'POST',
        body: CreateEmailOTPInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserRegisterByEmail
     * @request POST:/v1/user/email/register
     */
    userRegisterByEmail: (
      RegisterByEmailInput: UserRegisterByEmailInput,
      params: RequestParams = {},
    ) =>
      this.request<UserRegisterByEmailOutput, UserError>({
        path: `/v1/user/email/register`,
        method: 'POST',
        body: RegisterByEmailInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetFeatureFlags
     * @request GET:/v1/user/features
     */
    userGetFeatureFlags: (params: RequestParams = {}) =>
      this.request<UserGetFeatureFlagsOutput, UserError>({
        path: `/v1/user/features`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserUserInboxListMessages
     * @request GET:/v1/user/inbox/message
     */
    userUserInboxListMessages: (
      query: UserUserInboxListMessagesParams,
      params: RequestParams = {},
    ) =>
      this.request<UserInboxListMessagesOutput, UserError>({
        path: `/v1/user/inbox/message`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserUserInboxMarkAsRead
     * @request POST:/v1/user/inbox/read
     */
    userUserInboxMarkAsRead: (
      InboxMarkReadInput: UserInboxMarkReadInput,
      params: RequestParams = {},
    ) =>
      this.request<UserInboxMarkAsReadOutput, UserError>({
        path: `/v1/user/inbox/read`,
        method: 'POST',
        body: InboxMarkReadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserUserInboxMarkAllAsRead
     * @request POST:/v1/user/inbox/read/all
     */
    userUserInboxMarkAllAsRead: (
      InboxMarkAllReadInput: UserInboxMarkAllReadInput,
      params: RequestParams = {},
    ) =>
      this.request<UserInboxMarkAllAsReadOutput, UserError>({
        path: `/v1/user/inbox/read/all`,
        method: 'POST',
        body: InboxMarkAllReadInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserVerifyPhoneOwner
     * @request POST:/v1/user/kyc/quick
     */
    userVerifyPhoneOwner: (
      QuickKYCInput: UserQuickKYCInput,
      params: RequestParams = {},
    ) =>
      this.request<UserQuickKYCOutput, UserError>({
        path: `/v1/user/kyc/quick`,
        method: 'POST',
        body: QuickKYCInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserVerifyPersonalInfo
     * @request POST:/v1/user/kyc/quick-verify
     */
    userVerifyPersonalInfo: (
      QuickKYCVerifyInput: UserQuickKYCVerifyInput,
      params: RequestParams = {},
    ) =>
      this.request<UserQuickKYCVerifyOutput, UserError>({
        path: `/v1/user/kyc/quick-verify`,
        method: 'POST',
        body: QuickKYCVerifyInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserStartVideoKyc
     * @request POST:/v1/user/kyc/video
     */
    userStartVideoKyc: (
      VideoKYCStartInput: UserVideoKYCStartInput,
      params: RequestParams = {},
    ) =>
      this.request<UserStartVideoKYCOutput, UserError>({
        path: `/v1/user/kyc/video`,
        method: 'POST',
        body: VideoKYCStartInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserAddVideoKycDocument
     * @request POST:/v1/user/kyc/video/add
     */
    userAddVideoKycDocument: (
      AddVideoDocumentInput: UserAddVideoDocumentInput,
      params: RequestParams = {},
    ) =>
      this.request<UserKYCDocument, UserError>({
        path: `/v1/user/kyc/video/add`,
        method: 'POST',
        body: AddVideoDocumentInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserUploadVideoKycDocument
     * @request POST:/v1/user/kyc/video/upload
     * @deprecated
     */
    userUploadVideoKycDocument: (params: RequestParams = {}) =>
      this.request<UserUploadedDocument, UserError>({
        path: `/v1/user/kyc/video/upload`,
        method: 'POST',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetProvinces
     * @request GET:/v1/user/location/province
     */
    userGetProvinces: (params: RequestParams = {}) =>
      this.request<UserGetProvincesResponse, UserError>({
        path: `/v1/user/location/province`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetCounties
     * @request GET:/v1/user/location/province/{provinceID}/county
     */
    userGetCounties: (
      { provinceId, ...query }: UserGetCountiesParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetCountiesResponse, UserError>({
        path: `/v1/user/location/province/${provinceId}/county`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetCities
     * @request GET:/v1/user/location/province/{provinceID}/county/{countyID}
     */
    userGetCities: (
      { countyId, provinceId, ...query }: UserGetCitiesParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetCitiesResponse, UserError>({
        path: `/v1/user/location/province/${provinceId}/county/${countyId}`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetDistricts
     * @request GET:/v1/user/location/province/{provinceID}/county/{countyID}/district
     */
    userGetDistricts: (
      { countyId, provinceId, ...query }: UserGetDistrictsParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetDistrictsResponse, UserError>({
        path: `/v1/user/location/province/${provinceId}/county/${countyId}/district`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetLoyaltyMissions
     * @request GET:/v1/user/loyalty/missions
     */
    userGetLoyaltyMissions: (params: RequestParams = {}) =>
      this.request<UserGetMissionsOutput, UserError>({
        path: `/v1/user/loyalty/missions`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetLoyaltyPortfolio
     * @request GET:/v1/user/loyalty/portfolio
     */
    userGetLoyaltyPortfolio: (params: RequestParams = {}) =>
      this.request<UserGetPortfolioOutput, UserError>({
        path: `/v1/user/loyalty/portfolio`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetLoyaltyTransactionHistory
     * @request GET:/v1/user/loyalty/txn/history
     */
    userGetLoyaltyTransactionHistory: (
      query: UserGetLoyaltyTransactionHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetHistoryOutput, UserError>({
        path: `/v1/user/loyalty/txn/history`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserOtcPlaceOrder
     * @request POST:/v1/user/otc/order
     */
    userOtcPlaceOrder: (
      OTCPlaceOrderInput: UserOTCPlaceOrderInput,
      params: RequestParams = {},
    ) =>
      this.request<UserPlaceOTCOrderOutput, UserError>({
        path: `/v1/user/otc/order`,
        method: 'POST',
        body: OTCPlaceOrderInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserOtcPlaceConvertOrder
     * @request POST:/v1/user/otc/order/convert
     */
    userOtcPlaceConvertOrder: (
      OTCPlaceConvertOrderInput: UserOTCPlaceConvertOrderInput,
      params: RequestParams = {},
    ) =>
      this.request<UserPlaceConvertOrderOutput, UserError>({
        path: `/v1/user/otc/order/convert`,
        method: 'POST',
        body: OTCPlaceConvertOrderInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserOtcGetConvertRate
     * @request GET:/v1/user/otc/order/convert_rate
     */
    userOtcGetConvertRate: (
      query: UserOtcGetConvertRateParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetConvertRateOutput, UserError>({
        path: `/v1/user/otc/order/convert_rate`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserOtcFinalizeConvertOrder
     * @request POST:/v1/user/otc/order/finalize
     */
    userOtcFinalizeConvertOrder: (
      OTCFinalizeConvertOrderInput: UserOTCFinalizeConvertOrderInput,
      params: RequestParams = {},
    ) =>
      this.request<UserFinalizeConvertOrderOutput, UserError>({
        path: `/v1/user/otc/order/finalize`,
        method: 'POST',
        body: OTCFinalizeConvertOrderInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserOtcPayOrder
     * @request POST:/v1/user/otc/order/pay
     */
    userOtcPayOrder: (
      OTCPayOrderInput: UserOTCPayOrderInput,
      params: RequestParams = {},
    ) =>
      this.request<UserPayOrderOutput, UserError>({
        path: `/v1/user/otc/order/pay`,
        method: 'POST',
        body: OTCPayOrderInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetOtcPrice
     * @request GET:/v1/user/otc/price
     */
    userGetOtcPrice: (
      query: UserGetOtcPriceParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetPriceOutput, UserError>({
        path: `/v1/user/otc/price`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserOtcGetHistory
     * @request GET:/v1/user/otc/txn/history
     */
    userOtcGetHistory: (
      query: UserOtcGetHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetOTCHistoryOutput, UserError>({
        path: `/v1/user/otc/txn/history`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserResendOtp
     * @request POST:/v1/user/otp/resend
     */
    userResendOtp: (
      ResendOTPInput: UserResendOTPInput,
      params: RequestParams = {},
    ) =>
      this.request<UserResendOTPOutput, UserError>({
        path: `/v1/user/otp/resend`,
        method: 'POST',
        body: ResendOTPInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserLoginByPassword
     * @request POST:/v1/user/password/login
     */
    userLoginByPassword: (
      LoginByPasswordInput: UserLoginByPasswordInput,
      params: RequestParams = {},
    ) =>
      this.request<UserLoginByPasswordOutput, UserError>({
        path: `/v1/user/password/login`,
        method: 'POST',
        body: LoginByPasswordInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetPasswordSettings
     * @request GET:/v1/user/password/settings
     */
    userGetPasswordSettings: (params: RequestParams = {}) =>
      this.request<UserGetPasswordSettingsOutput, UserError>({
        path: `/v1/user/password/settings`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserSetPasswordSettings
     * @request PATCH:/v1/user/password/settings
     */
    userSetPasswordSettings: (
      SetPasswordSettingsInput: UserSetPasswordSettingsInput,
      params: RequestParams = {},
    ) =>
      this.request<UserSetPasswordSettingsOutput, UserError>({
        path: `/v1/user/password/settings`,
        method: 'PATCH',
        body: SetPasswordSettingsInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetAvailableCryptoContracts
     * @request GET:/v1/user/payment/crypto/contracts
     */
    userGetAvailableCryptoContracts: (
      query: UserGetAvailableCryptoContractsParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetAvailableCryptoContractsOutput, UserError>({
        path: `/v1/user/payment/crypto/contracts`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserInitiateCryptoDeposit
     * @request POST:/v1/user/payment/deposit/crypto/initiate
     */
    userInitiateCryptoDeposit: (
      InitiateCryptoDepositInput: UserInitiateCryptoDepositInput,
      params: RequestParams = {},
    ) =>
      this.request<UserInitiateCryptoDepositOutput, UserError>({
        path: `/v1/user/payment/deposit/crypto/initiate`,
        method: 'POST',
        body: InitiateCryptoDepositInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserCalculateFiatDepositCost
     * @request POST:/v1/user/payment/deposit/fiat/cost
     */
    userCalculateFiatDepositCost: (
      CalculateFiatDepositCostInput: UserCalculateFiatDepositCostInput,
      params: RequestParams = {},
    ) =>
      this.request<UserCalculateFiatDepositCostOutput, UserError>({
        path: `/v1/user/payment/deposit/fiat/cost`,
        method: 'POST',
        body: CalculateFiatDepositCostInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserPaymentInitiateFiatDeposit
     * @request POST:/v1/user/payment/deposit/fiat/initiate
     */
    userPaymentInitiateFiatDeposit: (
      PaymentInitiateFiatDepositInput: UserPaymentInitiateFiatDepositInput,
      params: RequestParams = {},
    ) =>
      this.request<UserPaymentInitiateFiatDepositOutput, UserError>({
        path: `/v1/user/payment/deposit/fiat/initiate`,
        method: 'POST',
        body: PaymentInitiateFiatDepositInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserPaymentVerifyFiatDeposit
     * @request POST:/v1/user/payment/deposit/fiat/verify
     */
    userPaymentVerifyFiatDeposit: (
      PaymentVerifyFiatDepositInput: UserPaymentVerifyFiatDepositInput,
      params: RequestParams = {},
    ) =>
      this.request<UserPaymentVerifyFiatDepositOutput, UserError>({
        path: `/v1/user/payment/deposit/fiat/verify`,
        method: 'POST',
        body: PaymentVerifyFiatDepositInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetAvailablePaymentGateways
     * @request GET:/v1/user/payment/fiat/gateways
     */
    userGetAvailablePaymentGateways: (params: RequestParams = {}) =>
      this.request<UserGetAvailableGatewaysOutput, UserError>({
        path: `/v1/user/payment/fiat/gateways`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetFiatTransactionHistory
     * @request POST:/v1/user/payment/fiat/history
     */
    userGetFiatTransactionHistory: (
      GetFiatTransactionHistoryInput: UserGetFiatTransactionHistoryInput,
      params: RequestParams = {},
    ) =>
      this.request<UserGetFiatTransactionHistoryOutput, UserError>({
        path: `/v1/user/payment/fiat/history`,
        method: 'POST',
        body: GetFiatTransactionHistoryInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserCancelFiatWithdrawal
     * @request PATCH:/v1/user/payment/withdrawal/fiat/cancel
     */
    userCancelFiatWithdrawal: (
      CancelFiatWithdrawalInput: UserCancelFiatWithdrawalInput,
      params: RequestParams = {},
    ) =>
      this.request<UserCancelFiatWithdrawalOutput, UserError>({
        path: `/v1/user/payment/withdrawal/fiat/cancel`,
        method: 'PATCH',
        body: CancelFiatWithdrawalInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserCalculateWithdrawalCost
     * @request POST:/v1/user/payment/withdrawal/fiat/cost
     */
    userCalculateWithdrawalCost: (
      CalculateWithdrawalCostInput: UserCalculateWithdrawalCostInput,
      params: RequestParams = {},
    ) =>
      this.request<UserCalculateWithdrawalCostOutput, UserError>({
        path: `/v1/user/payment/withdrawal/fiat/cost`,
        method: 'POST',
        body: CalculateWithdrawalCostInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserInitiateFiatWithdrawal
     * @request POST:/v1/user/payment/withdrawal/fiat/initiate
     */
    userInitiateFiatWithdrawal: (
      FiatWithdrawInput: UserFiatWithdrawInput,
      params: RequestParams = {},
    ) =>
      this.request<UserFiatWithdrawOutput, UserError>({
        path: `/v1/user/payment/withdrawal/fiat/initiate`,
        method: 'POST',
        body: FiatWithdrawInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserSetUserPhone
     * @request PATCH:/v1/user/phone
     */
    userSetUserPhone: (
      SetUserPhoneInput: UserSetUserPhoneInput,
      params: RequestParams = {},
    ) =>
      this.request<UserUser, UserError>({
        path: `/v1/user/phone`,
        method: 'PATCH',
        body: SetUserPhoneInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserLoginByPhone
     * @request POST:/v1/user/phone/login
     */
    userLoginByPhone: (
      LoginByPhoneInput: UserLoginByPhoneInput,
      params: RequestParams = {},
    ) =>
      this.request<UserLoginByPhoneOutput, UserError>({
        path: `/v1/user/phone/login`,
        method: 'POST',
        body: LoginByPhoneInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserCreatePhoneOtp
     * @request POST:/v1/user/phone/otp
     */
    userCreatePhoneOtp: (
      CreateOTPInput: UserCreateOTPInput,
      params: RequestParams = {},
    ) =>
      this.request<UserCreateOTPOutput, UserError>({
        path: `/v1/user/phone/otp`,
        method: 'POST',
        body: CreateOTPInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserRegisterByPhone
     * @request POST:/v1/user/phone/register
     */
    userRegisterByPhone: (
      RegisterByPhoneInput: UserRegisterByPhoneInput,
      params: RequestParams = {},
    ) =>
      this.request<UserRegisterByPhoneOutput, UserError>({
        path: `/v1/user/phone/register`,
        method: 'POST',
        body: RegisterByPhoneInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetUserPortfolio
     * @request GET:/v1/user/portfolio
     */
    userGetUserPortfolio: (params: RequestParams = {}) =>
      this.request<UserGetUserPortfolioOutput, UserError>({
        path: `/v1/user/portfolio`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetUserPortfolioChart
     * @request POST:/v1/user/portfolio/chart
     */
    userGetUserPortfolioChart: (
      GetPortfolioChartInput: UserGetPortfolioChartInput,
      params: RequestParams = {},
    ) =>
      this.request<UserGetPortfolioChartOutput, UserError>({
        path: `/v1/user/portfolio/chart`,
        method: 'POST',
        body: GetPortfolioChartInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetWalletPortfolioChart
     * @request POST:/v1/user/portfolio/chart/wallet
     */
    userGetWalletPortfolioChart: (
      GetWalletPortfolioChartInput: UserGetWalletPortfolioChartInput,
      params: RequestParams = {},
    ) =>
      this.request<UserGetWalletPortfolioChartOutput, UserError>({
        path: `/v1/user/portfolio/chart/wallet`,
        method: 'POST',
        body: GetWalletPortfolioChartInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetUserPerformance
     * @request GET:/v1/user/portfolio/performance
     */
    userGetUserPerformance: (params: RequestParams = {}) =>
      this.request<UserGetUserPerformanceOutput, UserError>({
        path: `/v1/user/portfolio/performance`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetMarketPricePerformance
     * @request GET:/v1/user/price/market/performance
     */
    userGetMarketPricePerformance: (params: RequestParams = {}) =>
      this.request<UserGetMarketPricePerformanceOutput, UserError>({
        path: `/v1/user/price/market/performance`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetPricePerformance
     * @request GET:/v1/user/price/performance
     */
    userGetPricePerformance: (
      query: UserGetPricePerformanceParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetPricePerformanceOutput, UserError>({
        path: `/v1/user/price/performance`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetProjectPosts
     * @request GET:/v1/user/project/posts
     */
    userGetProjectPosts: (
      query: UserGetProjectPostsParams,
      params: RequestParams = {},
    ) =>
      this.request<UserListPostsOutput, UserError>({
        path: `/v1/user/project/posts`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetProjectPriceChart
     * @request GET:/v1/user/project/price/chart
     */
    userGetProjectPriceChart: (
      query: UserGetProjectPriceChartParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetPriceChartOutput, UserError>({
        path: `/v1/user/project/price/chart`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetProjectPriceChartSnapshot
     * @request GET:/v1/user/project/price/chart/snapshot
     */
    userGetProjectPriceChartSnapshot: (
      query: UserGetProjectPriceChartSnapshotParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetPriceChartOutput, UserError>({
        path: `/v1/user/project/price/chart/snapshot`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetRecentlyVisitedProjects
     * @request GET:/v1/user/project/recently_visited
     */
    userGetRecentlyVisitedProjects: (
      query: UserGetRecentlyVisitedProjectsParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetRecentlyVisitedOutput, UserError>({
        path: `/v1/user/project/recently_visited`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetProjectDetails
     * @request GET:/v1/user/project/{token}
     */
    userGetProjectDetails: (
      { token, ...query }: UserGetProjectDetailsParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetProjectOutput, UserError>({
        path: `/v1/user/project/${token}`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetProjectCertDetails
     * @request GET:/v1/user/project/{token}/cert
     */
    userGetProjectCertDetails: (
      { token, ...query }: UserGetProjectCertDetailsParams,
      params: RequestParams = {},
    ) =>
      this.request<UserGetProjectCertOutput, UserError>({
        path: `/v1/user/project/${token}/cert`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserListProjects
     * @request GET:/v1/user/projects
     */
    userListProjects: (
      query: UserListProjectsParams,
      params: RequestParams = {},
    ) =>
      this.request<UserListProjectsOutput, UserError>({
        path: `/v1/user/projects`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserListProjectsPost
     * @request POST:/v1/user/projects
     */
    userListProjectsPost: (
      ListProjectsInput: UserListProjectsInput,
      params: RequestParams = {},
    ) =>
      this.request<UserListProjectsOutput, UserError>({
        path: `/v1/user/projects`,
        method: 'POST',
        body: ListProjectsInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetReferralCodes
     * @request GET:/v1/user/referral/code
     */
    userGetReferralCodes: (params: RequestParams = {}) =>
      this.request<UserGetReferralCodesOutput, UserError>({
        path: `/v1/user/referral/code`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserListReferrals
     * @request GET:/v1/user/referral/list
     */
    userListReferrals: (
      query: UserListReferralsParams,
      params: RequestParams = {},
    ) =>
      this.request<UserListReferralsOutput, UserError>({
        path: `/v1/user/referral/list`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserAuthRefresh
     * @request POST:/v1/user/refresh
     */
    userAuthRefresh: (
      RefreshTokenInput: UserRefreshTokenInput,
      params: RequestParams = {},
    ) =>
      this.request<UserRefreshTokenOutput, UserError>({
        path: `/v1/user/refresh`,
        method: 'POST',
        body: RefreshTokenInput,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserAuthVerify
     * @request GET:/v1/user/verify
     */
    userAuthVerify: (params: RequestParams = {}) =>
      this.request<UserUser, UserError>({
        path: `/v1/user/verify`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
}
